import "core-js/modules/esnext.global-this.js";
import { Builder, builder, Subscription, BehaviorSubject } from "@builder.io/sdk";
export { Builder, builder, builder as default } from "@builder.io/sdk";
import { jsx, ClassNames, css } from "@emotion/core";
import * as React from "react";
import React__default, { useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import hash from "hash-sum";
var version = "3.0.4",
  _a;
"undefined" != typeof window && (null === (_a = window.parent) || void 0 === _a || _a.postMessage({
  type: "builder.isReactSdk",
  data: {
    value: !0,
    supportsPatchUpdates: "v4",
    supportsCustomBreakpoints: !0,
    priorVersion: version
  }
}, "*"));
var _extendStatics = function extendStatics(e, t) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  })(e, t);
};
function __extends(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function n() {
    this.constructor = e;
  }
  _extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  }).apply(this, arguments);
};
function __decorate(e, t, n, i) {
  var r,
    o = arguments.length,
    a = o < 3 ? t : null === i ? i = Object.getOwnPropertyDescriptor(t, n) : i;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, i);else for (var s = e.length - 1; s >= 0; s--) (r = e[s]) && (a = (o < 3 ? r(a) : o > 3 ? r(t, n, a) : r(t, n)) || a);
  return o > 3 && a && Object.defineProperty(t, n, a), a;
}
function __metadata(e, t) {
  if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
}
function __awaiter(e, t, n, i) {
  return new (n || (n = Promise))(function (r, o) {
    function a(e) {
      try {
        l(i.next(e));
      } catch (e) {
        o(e);
      }
    }
    function s(e) {
      try {
        l(i.throw(e));
      } catch (e) {
        o(e);
      }
    }
    function l(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    l((i = i.apply(e, t || [])).next());
  });
}
function __generator(e, t) {
  var n,
    i,
    r,
    o,
    a = {
      label: 0,
      sent: function sent() {
        if (1 & r[0]) throw r[1];
        return r[1];
      },
      trys: [],
      ops: []
    };
  return o = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;
  function s(s) {
    return function (l) {
      return function (s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, s[0] && (a = 0)), a;) try {
          if (n = 1, i && (r = 2 & s[0] ? i.return : s[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, s[1])).done) return r;
          switch (i = 0, r && (s = [2 & s[0], r.value]), s[0]) {
            case 0:
            case 1:
              r = s;
              break;
            case 4:
              return a.label++, {
                value: s[1],
                done: !1
              };
            case 5:
              a.label++, i = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                a = 0;
                continue;
              }
              if (3 === s[0] && (!r || s[1] > r[0] && s[1] < r[3])) {
                a.label = s[1];
                break;
              }
              if (6 === s[0] && a.label < r[1]) {
                a.label = r[1], r = s;
                break;
              }
              if (r && a.label < r[2]) {
                a.label = r[2], a.ops.push(s);
                break;
              }
              r[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (e) {
          s = [6, e], i = 0;
        } finally {
          n = r = 0;
        }
        if (5 & s[0]) throw s[1];
        return {
          value: s[0] ? s[1] : void 0,
          done: !0
        };
      }([s, l]);
    };
  }
}
function __spreadArray(e, t, n) {
  if (n || 2 === arguments.length) for (var i, r = 0, o = t.length; r < o; r++) !i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var fastClone = function fastClone(e) {
    return JSON.parse(JSON.stringify(e));
  },
  sizeNames = ["xsmall", "small", "medium", "large"],
  sizes = {
    xsmall: {
      min: 0,
      default: 0,
      max: 0
    },
    small: {
      min: 320,
      default: 321,
      max: 640
    },
    medium: {
      min: 641,
      default: 642,
      max: 991
    },
    large: {
      min: 990,
      default: 991,
      max: 1200
    },
    getWidthForSize: function getWidthForSize(e) {
      return this[e].default;
    },
    getSizeForWidth: function getSizeForWidth(e) {
      for (var t = 0, n = sizeNames; t < n.length; t++) {
        var i = n[t];
        if (e <= this[i].max) return i;
      }
      return "large";
    }
  },
  getSizesForBreakpoints = function getSizesForBreakpoints(e) {
    var t = e.small,
      n = e.medium,
      i = _assign(_assign({}, sizes), fastClone(sizes));
    if (!t || !n) return i;
    var r = Math.floor(t / 2);
    i.small = {
      max: t,
      min: r,
      default: r + 1
    };
    var o = i.small.max + 1;
    i.medium = {
      max: n,
      min: o,
      default: o + 1
    };
    var a = i.medium.max + 1;
    return i.large = {
      max: 2e3,
      min: a,
      default: a + 1
    }, i;
  },
  set = function set(e, t, n) {
    if (Object(e) !== e) return e;
    var i = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
    return i.slice(0, -1).reduce(function (e, t, n) {
      return Object(e[t]) === e[t] ? e[t] : e[t] = Math.abs(Number(i[n + 1])) >> 0 == +i[n + 1] ? [] : {};
    }, e)[i[i.length - 1]] = n, e;
  },
  noop = function noop() {
    return null;
  },
  safeDynamicRequire;
if ("function" == typeof (null === globalThis || void 0 === globalThis ? void 0 : globalThis.require) || Builder.isServer && "function" == typeof require) try {
  safeDynamicRequire = eval("require");
} catch (e) {
  safeDynamicRequire = (null === globalThis || void 0 === globalThis ? void 0 : globalThis.require) ? globalThis.require : noop;
}
null != safeDynamicRequire || (safeDynamicRequire = noop);
var fnCache = {},
  api = function api(e) {
    return builder;
  };
function stringToFunction(e, t, n, i) {
  if (void 0 === t && (t = !0), !e || !e.trim()) return function () {};
  var r = e + ":" + t;
  if (fnCache[r]) return fnCache[r];
  var o = t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) || e.trim().startsWith("builder.run"),
    a = function a() {};
  try {
    Builder.isBrowser && (a = new Function("state", "event", "block", "builder", "Device", "update", "Builder", "context", "\n          var names = [\n            'state',\n            'event',\n            'block',\n            'builder',\n            'Device',\n            'update',\n            'Builder',\n            'context'\n          ];\n          var rootState = state;\n          if (typeof Proxy !== 'undefined') {\n            rootState = new Proxy(rootState, {\n              set: function () {\n                return false;\n              },\n              get: function (target, key) {\n                if (names.includes(key)) {\n                  return undefined;\n                }\n                return target[key];\n              }\n            });\n          }\n          /* Alias */\n          var ctx = context;\n          with (rootState) {\n            ".concat(o ? "return (".concat(e, ");") : e, ";\n          }\n        ")));
  } catch (t) {
    n && n.push(t);
    var s = t && t.message;
    s && "string" == typeof s && i && -1 === i.indexOf(s) && i.push(s), Builder.isBrowser && console.warn("Function compile error in ".concat(e), t);
  }
  var l = function l() {
    for (var t, i = [], r = 0; r < arguments.length; r++) i[r] = arguments[r];
    try {
      if (Builder.isBrowser) return a.apply(void 0, i);
      var o = safeDynamicRequire("vm2").VM,
        s = i[0],
        l = i[1],
        u = (i[2], i[3], i[4], i[5], i[6], i[7]);
      return new o({
        timeout: 100,
        sandbox: _assign(_assign(_assign(_assign(_assign({}, s), {
          state: s
        }), {
          context: u
        }), {
          builder: api
        }), {
          event: l
        })
      }).run(e.replace(/(^|;)return /, "$1"));
    } catch (i) {
      return Builder.isBrowser ? console.warn("Builder custom code error:", i.message || i, "in", e, i.stack || i) : (null === (t = null === process || void 0 === process ? void 0 : process.env) || void 0 === t ? void 0 : t.DEBUG) && console.debug("Builder custom code error:", i.message || i, "in", e, i.stack || i), n && n.push(i), null;
    }
  };
  return Builder.isBrowser && (fnCache[r] = l), l;
}
var isPromise = function isPromise(e) {
    return "function" == typeof e.then;
  },
  isRequestInfo = function isRequestInfo(e) {
    return !isPromise(e);
  },
  BuilderAsyncRequestsContext = React__default.createContext({
    requests: [],
    errors: [],
    logs: []
  }),
  BuilderStoreContext = React__default.createContext({
    state: {},
    rootState: {},
    content: {},
    context: {},
    update: function update(e) {
      return null;
    }
  }),
  applyPatchWithMinimalMutationChain = function applyPatchWithMinimalMutationChain(e, t, n) {
    if (void 0 === n && (n = !1), Object(e) !== e) return e;
    var i = t.path,
      r = t.op,
      o = t.value,
      a = i.split(/\//);
    "" === a[0] && a.shift();
    for (var s = n ? e : _assign({}, e), l = s, u = 0; u < a.length; u++) {
      var d = u === a.length - 1,
        c = a[u];
      if (d) {
        if ("replace" === r) l[c] = o;else if ("add" === r) {
          var p = Number(c);
          Array.isArray(l) ? "-" === c ? l.push(o) : l.splice(p, 0, o) : l[c] = o;
        } else if ("remove" === r) {
          p = Number(c);
          Array.isArray(l) ? l.splice(p, 1) : delete l[c];
        }
      } else {
        var f = a[u + 1],
          m = Object(l[c]) === l[c] ? l[c] : String(Number(f)) === f ? [] : {};
        l = l[c] = Array.isArray(m) ? __spreadArray([], m, !0) : _assign({}, m);
      }
    }
    return s;
  },
  htmlEscape = function htmlEscape(e) {
    return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  },
  blockToHtmlString = function blockToHtmlString(e) {
    var t;
    return "<".concat(htmlEscape(e.tagName || "div"), ' \n    class="builder-block ').concat(e.id, " ").concat(e.class || "", '"\n    builder-id="').concat(e.id, '"\n  ').concat(Object.keys(e.properties || {}).map(function (t) {
      return "".concat(htmlEscape(t), '="').concat(htmlEscape(e.properties[t]), '"');
    }).join(" "), "\n  >").concat("Text" === (null === (t = null == e ? void 0 : e.component) || void 0 === t ? void 0 : t.name) ? e.component.options.text : e.children ? e.children.map(function (e) {
      return blockToHtmlString(e);
    }).join("") : "", "</").concat(e.tagName || "div", ">").replace(/\s+/g, " ");
  },
  Link = function Link(e) {
    return React__default.createElement(BuilderStoreContext.Consumer, null, function (t) {
      return t.renderLink ? t.renderLink(e) : React__default.createElement("a", _assign({}, e));
    });
  },
  camelCaseToKebabCase = function camelCaseToKebabCase(e) {
    return e ? e.replace(/([A-Z])/g, function (e) {
      return "-".concat(e[0].toLowerCase());
    }) : "";
  },
  kebabCaseToCamelCase = function kebabCaseToCamelCase(e) {
    return void 0 === e && (e = ""), e.replace(/-([a-z])/g, function (e) {
      return e[1].toUpperCase();
    });
  },
  Device = {
    desktop: 0,
    tablet: 1,
    mobile: 2
  },
  voidElements = new Set(["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr", "textarea"]),
  last = function last(e) {
    return e[e.length - 1];
  };
function omit$1(e, t) {
  for (var n = Object.assign({}, e), i = 0, r = t; i < r.length; i++) {
    delete n[r[i]];
  }
  return n;
}
var cssCase = function cssCase(e) {
  if (!e) return e;
  var t = camelCaseToKebabCase(e);
  return e[0] === e[0].toUpperCase() && (t = "-" + t), t;
};
function capitalize(e) {
  if (e) return e[0].toUpperCase() + e.slice(1);
}
var BuilderBlock$1 = function (_super) {
    function BuilderBlock() {
      var _this = null !== _super && _super.apply(this, arguments) || this;
      return _this.state = {
        hasError: !1,
        updates: 0
      }, _this.privateState = {
        state: {},
        rootState: {},
        context: {},
        update: function update() {}
      }, _this.onWindowMessage = function (event) {
        var message = event.data;
        if (message) switch (message.type) {
          case "builder.selectionChange":
            var data = message.data;
            if (!data) break;
            var selection = data.selection,
              id = _this.block && _this.block.id;
            id && Array.isArray(selection) && selection.indexOf(id) > -1 && setTimeout(function () {
              window.$block = _this, window.$blocks || (window.$blocks = []), window.$blocks.push(_this);
            });
            break;
          case "builder.patchUpdates":
            var data = message.data;
            if (!data || !data.data) break;
            var patches = data.data[_this.block.id];
            if (!patches) return;
            location.href.includes("builder.debug=true") && eval("debugger");
            for (var _i = 0, patches_1 = patches; _i < patches_1.length; _i++) {
              var patch = patches_1[_i];
              applyPatchWithMinimalMutationChain(_this.props.block, patch, !0);
            }
            _this.setState({
              updates: _this.state.updates + 1
            });
        }
      }, _this;
    }
    return __extends(BuilderBlock, _super), Object.defineProperty(BuilderBlock.prototype, "store", {
      get: function get() {
        return this.privateState;
      },
      enumerable: !1,
      configurable: !0
    }), BuilderBlock.getDerivedStateFromError = function (e) {
      return {
        hasError: !0
      };
    }, BuilderBlock.prototype.componentDidCatch = function (e, t) {
      console.error("Builder block error:", e, t);
    }, BuilderBlock.prototype.stringToFunction = function (e, t) {
      return void 0 === t && (t = !0), stringToFunction(e, t, this._errors, this._logs);
    }, Object.defineProperty(BuilderBlock.prototype, "block", {
      get: function get() {
        return this.props.block;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(BuilderBlock.prototype, "emotionCss", {
      get: function get() {
        var e,
          t,
          n,
          i,
          r,
          o = this.block;
        if (Builder.isServer) {
          var a = o.animations && o.animations[0];
          if (a && "hover" !== a.trigger) {
            var s = a && a.steps && a.steps[0],
              l = s && s.styles;
            l && (r = l);
          }
        }
        var u = sizeNames.slice().reverse(),
          d = this.block,
          c = {};
        if (d.responsiveStyles) for (var p = 0, f = u; p < f.length; p++) {
          var m = f[p];
          if ("large" === m) this.props.emailMode || (c["&.builder-block"] = Object.assign({}, d.responsiveStyles[m], r));else {
            var h = getSizesForBreakpoints((null === (t = null === (e = this.privateState.context.builderContent) || void 0 === e ? void 0 : e.meta) || void 0 === t ? void 0 : t.breakpoints) || {});
            c["@media only screen and (max-width: ".concat(h[m].max, "px)")] = {
              "&.builder-block": d.responsiveStyles[m]
            };
          }
        }
        var g = o.animations && o.animations.find(function (e) {
          return "hover" === e.trigger;
        });
        return g && (c[":hover"] = (null === (i = null === (n = g.steps) || void 0 === n ? void 0 : n[1]) || void 0 === i ? void 0 : i.styles) || {}, c.transition = "all ".concat(g.duration, "s ").concat(camelCaseToKebabCase(g.easing)), g.delay && (c.transitionDelay = g.delay + "s")), c;
      },
      enumerable: !1,
      configurable: !0
    }), BuilderBlock.prototype.eval = function (e) {
      return this.stringToFunction(e)(this.privateState.state, void 0, this.block, builder, Device, this.privateState.update, Builder, this.privateState.context);
    }, BuilderBlock.prototype.componentWillUnmount = function () {
      Builder.isEditing && removeEventListener("message", this.onWindowMessage);
    }, BuilderBlock.prototype.componentDidMount = function () {
      var e,
        t = this,
        n = this.block,
        i = n && n.animations;
      if (Builder.isEditing && addEventListener("message", this.onWindowMessage), i) {
        var r = {
          animations: fastClone(i)
        };
        if (n.bindings) for (var o in n.bindings) if ((null === (e = o.trim) || void 0 === e ? void 0 : e.call(o)) && o.startsWith("animations.")) {
          var a = this.stringToFunction(n.bindings[o]);
          void 0 !== a && set(r, o, a(this.privateState.state, null, n, builder, null, null, Builder, this.privateState.context));
        }
        Builder.animator.bindAnimations(r.animations.filter(function (e) {
          return "hover" !== e.trigger;
        }).map(function (e) {
          return _assign(_assign({}, e), {
            elementId: t.block.id
          });
        }));
      }
    }, BuilderBlock.prototype.getElement = function (e, t) {
      var n,
        i,
        r,
        o,
        a,
        s = this;
      void 0 === e && (e = 0), void 0 === t && (t = this.privateState.state);
      var l = this.props;
      l.child, l.fieldName;
      var u,
        d = this.block,
        c = (d.tagName || "div").toLowerCase();
      if ("template" === c) {
        var p = d.children ? d.children.map(function (e) {
          return blockToHtmlString(e);
        }).join(" ") : "";
        return console.debug("template html", p), jsx("template", _assign({}, d.properties, {
          dangerouslySetInnerHTML: {
            __html: p
          }
        }));
      }
      var f = d.component && (d.component.name || d.component.component),
        m = null;
      d.component && !d.component.class && (d.component && d.component.tag ? u = d.component.tag : (m = Builder.components.find(function (e) {
        return e.name === f;
      }) || null) && m.class ? u = m.class : m && m.tag ? u = m.tag : (null == f ? void 0 : f.startsWith("Builder:")) ? console.warn("Missing @builder.io/widgets installation, please install and import @builder.io/widgets to use ".concat(f.split(":")[1], " in your content, more info here: https://github.com/BuilderIO/builder/tree/main/packages/widgets")) : f && console.warn("Missing registration for ".concat(f, ", have you included the registration in your bundle?")));
      var h = _assign(_assign({}, d.properties), {
        style: {}
      });
      if (h = _assign(_assign({}, h.properties), h), d.component && (h.component = fastClone(d.component)), d.bindings) for (var g in d.bindings) if (null === (i = g.trim) || void 0 === i ? void 0 : i.call(g)) {
        var v = this.stringToFunction(d.bindings[g]);
        set(h, g, v(t, null, d, api(), Device, null, Builder, this.privateState.context));
      }
      if (h.hide) return null;
      if (delete h.hide, ("show" in h || d.bindings && d.bindings.show) && !h.show) return null;
      if (delete h.show, d.actions) {
        var b = function b(e) {
          if (!(null === (r = e.trim) || void 0 === r ? void 0 : r.call(e))) return "continue";
          var n = d.actions[e];
          h["on" + capitalize(e)] = function (e) {
            var i = t;
            return "undefined" != typeof Proxy && (i = new Proxy(t, {
              set: function set(e, t, n) {
                return e[t] = n, s.privateState.rootState[t] = n, !0;
              }
            })), s.stringToFunction(n, !1)(i, e, s.block, builder, Device, s.privateState.update, Builder, s.privateState.context);
          };
        };
        for (var g in d.actions) b(g);
      }
      var y = (h.component || h.options) && _assign(_assign({}, h.options), h.component.options || h.component.data),
        _ = voidElements.has(c),
        x = m && (m.fragment || m.noWrap),
        S = (null === (o = h.attr) || void 0 === o ? void 0 : o.style) || ("string" == typeof h.style ? h.style : "") || "";
      if ("string" == typeof S) {
        "object" != typeof h.style && (h.style = {});
        for (var B = 0, k = S.split(";"); B < k.length; B++) {
          var w = k[B].split(":");
          if (!w.length) return;
          g = w[0], v = w[1];
          g && (w.length > 2 && (v = w.slice(1).join(":")), h.style[kebabCaseToCamelCase(g)] = v);
        }
      }
      var C = _assign(_assign(_assign({}, omit$1(h, ["class", "component", "attr"])), ((n = {})["string" != typeof c || c.includes("-") ? "class" : "className"] = "builder-block ".concat(this.id).concat(d.class ? " ".concat(d.class) : "").concat(!d.component || ["Image", "Video", "Banner"].indexOf(f) > -1 ? "" : " builder-has-component") + (h.class ? " " + h.class : "") + (Builder.isEditing && (null === (a = this.privateState.state._spacer) || void 0 === a ? void 0 : a.parent) === d.id ? " builder-spacer-parent" : ""), n.key = this.id + e, n["builder-id"] = this.id, n)), 0 !== e && {
        "builder-index": e
      });
      Builder.isEditing && (C["builder-inline-styles"] = h.attr && h.attr.style ? Object.keys(h.style).reduce(function (e, t) {
        return (e ? "".concat(e, ";") : "") + "".concat(cssCase(t), ":").concat(h.style[t], ";");
      }, "") : ""), (C.properties && C.properties.href || C.href) && "div" === c && (c = "a"), "a" === c && (c = Link);
      var R = d.children || C.children || [];
      return jsx(React__default.Fragment, null, jsx(ClassNames, null, function (e) {
        var t = e.css;
        if (e.cx, !s.props.emailMode) {
          var n = " " + t(s.emotionCss);
          C.class && (C.class += n), C.className && (C.className += n);
        }
        return jsx(BuilderAsyncRequestsContext.Consumer, null, function (e) {
          return s._asyncRequests = e && e.requests, s._errors = e && e.errors, s._logs = e && e.logs, _ ? jsx(c, _assign({}, C)) : u && (x || s.props.emailMode) ? jsx(u, _assign({}, y, {
            attributes: C,
            builderBlock: d,
            builderState: s.privateState
          })) : jsx(c, _assign({}, C), u && jsx(u, _assign({
            builderState: s.privateState,
            builderBlock: d
          }, y)), d.text || h.text ? h.text : !u && R && Array.isArray(R) && R.length ? R.map(function (e, t) {
            return jsx(BuilderBlock, {
              key: (s.id || "") + t,
              block: e,
              index: t,
              size: s.props.size,
              fieldName: s.props.fieldName,
              child: s.props.child,
              emailMode: s.props.emailMode
            });
          }) : null);
        });
      }));
    }, Object.defineProperty(BuilderBlock.prototype, "id", {
      get: function get() {
        var e = this.block;
        return e.id.startsWith("builder") ? e.id : "builder-" + e.id;
      },
      enumerable: !1,
      configurable: !0
    }), BuilderBlock.prototype.contents = function (e) {
      var t = this,
        n = this.block;
      if (this.privateState = e, n.repeat && n.repeat.collection) {
        var i = n.repeat.collection,
          r = last((i || "").trim().split("(")[0].trim().split(".")),
          o = n.repeat.itemName || (r ? r + "Item" : "item"),
          a = this.stringToFunction(i)(e.state, null, n, api(), Device, null, Builder, this.privateState.context);
        return Array.isArray(a) ? a.map(function (n, i) {
          var r,
            a = _assign(_assign({}, e.state), ((r = {
              $index: i,
              $item: n
            })[o] = n, r["$".concat(o, "Index")] = i, r));
          return jsx(BuilderStoreContext.Provider, {
            key: i,
            value: _assign(_assign({}, e), {
              state: a
            })
          }, t.getElement(i, a));
        }) : null;
      }
      return this.getElement();
    }, BuilderBlock.prototype.render = function () {
      var e = this;
      return this.state.hasError ? jsx("span", {
        css: {
          display: "inline-block",
          padding: 5,
          color: "#999",
          fontSize: 11,
          fontStyle: "italic"
        }
      }, "Builder block error :( Check console for details") : jsx(BuilderStoreContext.Consumer, null, function (t) {
        return e.contents(t);
      });
    }, BuilderBlock;
  }(React__default.Component),
  BuilderBlocks = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.onClickEmptyBlocks = function () {
        var e;
        Builder.isIframe && t.noBlocks && (null === (e = window.parent) || void 0 === e || e.postMessage({
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: t.parentId,
            dataPath: t.path
          }
        }, "*"));
      }, t.onHoverEmptyBlocks = function () {
        var e;
        Builder.isEditing && t.noBlocks && (null === (e = window.parent) || void 0 === e || e.postMessage({
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: t.parentId,
            dataPath: t.path
          }
        }, "*"));
      }, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "isRoot", {
      get: function get() {
        return !this.props.child;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "noBlocks", {
      get: function get() {
        var e = this.props.blocks;
        return !(e && e.length);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "path", {
      get: function get() {
        var e = this.props.dataPath || "";
        return e.trim() && (e.startsWith("this.") ? e = e.replace("this.", "") : e.startsWith("component.options.") || (e = "component.options." + e)), e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "parentId", {
      get: function get() {
        return this.props.parentElementId ? this.props.parentElementId : this.props.parent && this.props.parent.id;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e = this,
        t = this.props.blocks,
        n = this.props.emailMode ? "span" : "div";
      return jsx(n, _assign({
        className: "builder-blocks" + (this.noBlocks ? " no-blocks" : "") + (this.props.child ? " builder-blocks-child" : "") + (this.props.className ? " " + this.props.className : ""),
        "builder-type": "blocks",
        "builder-path": Builder.isIframe ? this.path : void 0,
        "builder-parent-id": this.parentId,
        css: _assign(_assign({}, !this.props.emailMode && {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        }), this.props.style),
        onClick: function onClick() {
          e.noBlocks && e.onClickEmptyBlocks();
        }
      }, Builder.isEditing && {
        onMouseEnter: function onMouseEnter() {
          return e.onHoverEmptyBlocks();
        }
      }), t && Array.isArray(t) && t.map(function (t, n) {
        return t && "@builder.io/sdk:Element" === t["@type"] ? jsx(BuilderBlock$1, {
          key: t.id,
          block: t,
          index: n,
          fieldName: e.props.fieldName,
          child: e.props.child,
          emailMode: e.props.emailMode
        }) : t;
      }) || t);
    }, t.renderInto = function (e, n, i) {
      if (void 0 === n && (n = {}), e) {
        var r = null;
        return "string" == typeof e ? r = document.querySelector(e) : e instanceof Element && (r = e), ReactDOM.render(jsx(BuilderStoreContext.Provider, {
          value: i
        }, jsx(t, _assign({}, n))), r);
      }
    }, t;
  }(React__default.Component),
  NoWrap = function NoWrap(e) {
    return e.children;
  };
function getData(e) {
  if (void 0 !== (null == e ? void 0 : e.data)) {
    var t = e.data,
      n = t.blocks,
      i = t.blocksString,
      r = Array.isArray(n) || "string" == typeof i,
      o = _assign(_assign({}, e.data), r && {
        blocks: n || JSON.parse(i)
      });
    return delete o.blocksString, o;
  }
}
var variantsScript = function variantsScript(e, t) {
    return "\n(function() {\n  if (window.builderNoTrack || !navigator.cookieEnabled) {\n    return;\n  }\n\n  var variants = ".concat(e, ";\n  function removeVariants() {\n    variants.forEach(function (template) {\n      document.querySelector('template[data-template-variant-id=\"' + template.id + '\"]').remove();\n    });\n    document.getElementById('variants-script-").concat(t, '\').remove();\n  }\n\n  if (typeof document.createElement("template").content === \'undefined\') {\n    removeVariants();\n    return ;\n  }\n\n  function setCookie(name,value,days) {\n    var expires = "";\n    if (days) {\n        var date = new Date();\n        date.setTime(date.getTime() + (days*24*60*60*1000));\n        expires = "; expires=" + date.toUTCString();\n    }\n    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + "; Secure; SameSite=None";\n  }\n\n  function getCookie(name) {\n    var nameEQ = name + "=";\n    var ca = document.cookie.split(\';\');\n    for(var i=0;i < ca.length;i++) {\n        var c = ca[i];\n        while (c.charAt(0)==\' \') c = c.substring(1,c.length);\n        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);\n    }\n    return null;\n  }\n  var cookieName = \'builder.tests.').concat(t, "';\n  var variantInCookie = getCookie(cookieName);\n  var availableIDs = variants.map(function(vr) { return vr.id }).concat('").concat(t, "');\n  var variantId;\n  if (availableIDs.indexOf(variantInCookie) > -1) {\n    variantId = variantInCookie;\n  }\n  if (!variantId) {\n    var n = 0;\n    var random = Math.random();\n    for (var i = 0; i < variants.length; i++) {\n      var variant = variants[i];\n      var testRatio = variant.testRatio;\n      n += testRatio;\n      if (random < n) {\n        setCookie(cookieName, variant.id);\n        variantId = variant.id;\n        break;\n      }\n    }\n    if (!variantId) {\n      variantId = \"").concat(t, '";\n      setCookie(cookieName, "').concat(t, '");\n    }\n  }\n  if (variantId && variantId !== "').concat(t, "\") {\n    var winningTemplate = document.querySelector('template[data-template-variant-id=\"' + variantId + '\"]');\n    if (winningTemplate) {\n      var parentNode = winningTemplate.parentNode;\n      var newParent = parentNode.cloneNode(false);\n      newParent.appendChild(winningTemplate.content.firstChild);\n      parentNode.parentNode.replaceChild(newParent, parentNode);\n    }\n  } else if (variants.length > 0) {\n    removeVariants();\n  }\n})()").replace(/\s+/g, " ");
  },
  VariantsProvider = function VariantsProvider(e) {
    var t = e.initialContent,
      n = e.children;
    if (Builder.isBrowser && !builder.canTrack) return n([t]);
    if (!Boolean(Object.keys((null == t ? void 0 : t.variations) || {}).length)) return n([t]);
    var i = Object.keys(t.variations).map(function (e) {
        return _assign(_assign({
          id: e
        }, t.variations[e]), {
          data: getData(t.variations[e])
        });
      }),
      r = __spreadArray(__spreadArray([], i, !0), [t], !1);
    if (Builder.isServer) {
      var o = JSON.stringify(Object.keys(t.variations || {}).map(function (e) {
        return {
          id: e,
          testRatio: t.variations[e].testRatio
        };
      }));
      return React.createElement(React.Fragment, null, n(r, function () {
        return React.createElement("script", {
          id: "variants-script-".concat(t.id),
          dangerouslySetInnerHTML: {
            __html: variantsScript(o, t.id)
          }
        });
      }));
    }
    var a = "builder.tests.".concat(t.id),
      s = builder.getCookie(a);
    if (!s && Builder.isBrowser) for (var l = 0, u = Math.random(), d = 0; d < i.length; d++) {
      var c = i[d];
      if (u < (l += c.testRatio)) {
        builder.setCookie(a, c.id), s = c.id;
        break;
      }
    }
    return s || (s = t.id, builder.setCookie(a, s)), n([r.find(function (e) {
      return e.id === s;
    })]);
  },
  BuilderContent = function (_super) {
    function BuilderContent() {
      var _this = null !== _super && _super.apply(this, arguments) || this;
      return _this.ref = null, _this.state = {
        loading: !_this.props.content,
        data: getContentWithInfo(_this.props.content),
        updates: 1
      }, _this.onWindowMessage = function (event) {
        var _a,
          _b,
          message = event.data;
        if (message) switch (message.type) {
          case "builder.patchUpdates":
            if (null === (_a = _this.props.options) || void 0 === _a ? void 0 : _a.noEditorUpdates) return;
            var data = message.data;
            if (!data || !data.data) break;
            var patches = data.data[null === (_b = _this.state.data) || void 0 === _b ? void 0 : _b.id];
            if (!patches || !patches.length) return;
            location.href.includes("builder.debug=true") && eval("debugger");
            for (var newData = _this.state.data, _i = 0, patches_1 = patches; _i < patches_1.length; _i++) {
              var patch = patches_1[_i];
              newData = applyPatchWithMinimalMutationChain(newData, patch, !1);
            }
            _this.setState({
              updates: _this.state.updates + 1,
              data: newData
            }), _this.props.contentLoaded && _this.props.contentLoaded(newData.data, newData);
        }
      }, _this.subscriptions = new Subscription(), _this.firstLoad = !0, _this.clicked = !1, _this.trackedImpression = !1, _this.intersectionObserver = null, _this.onClick = function (e) {
        var t = e.nativeEvent,
          n = _this.data;
        n && (builder.autoTrack && _this.builder.trackInteraction(n.id, _this.renderedVariantId, _this.clicked, t, {
          content: n
        }), _this.clicked || (_this.clicked = !0));
      }, _this;
    }
    return __extends(BuilderContent, _super), Object.defineProperty(BuilderContent.prototype, "builder", {
      get: function get() {
        return this.props.builder || builder;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(BuilderContent.prototype, "name", {
      get: function get() {
        var e = this.props;
        return "model" in e ? e.model : e.modelName;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(BuilderContent.prototype, "renderedVariantId", {
      get: function get() {
        var e,
          t,
          n = this.props.isStatic ? this.builder.getCookie("builder.tests.".concat(null === (e = this.data) || void 0 === e ? void 0 : e.id)) : null === (t = this.data) || void 0 === t ? void 0 : t.variationId;
        if (null !== n) return n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(BuilderContent.prototype, "options", {
      get: function get() {
        var e,
          t,
          n = _assign({}, this.props.options || {});
        return n.key || !(null === (e = this.props.content) || void 0 === e ? void 0 : e.id) || Builder.isEditing || Builder.isPreviewing || (n.key = this.props.content.id), !this.props.content || (null === (t = n.initialContent) || void 0 === t ? void 0 : t.length) || !this.props.inline && Builder.isPreviewing || (n.initialContent = [this.props.content]), n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(BuilderContent.prototype, "data", {
      get: function get() {
        var e = (this.props.inline || !Builder.isBrowser || this.firstLoad) && this.options.initialContent && this.options.initialContent[0] || this.state.data;
        return getContentWithInfo(e);
      },
      enumerable: !1,
      configurable: !0
    }), BuilderContent.prototype.componentDidMount = function () {
      var e, t;
      if (!this.props.inline || Builder.isEditing || Builder.isPreviewing) this.subscribeToContent();else if (this.props.inline && (null === (t = null === (e = this.options) || void 0 === e ? void 0 : e.initialContent) || void 0 === t ? void 0 : t.length)) {
        var n = this.options.initialContent[0];
        (null == n ? void 0 : n.id) && this.builder.trackImpression(n.id, this.renderedVariantId, void 0, {
          content: n
        });
      }
      Builder.isEditing && addEventListener("message", this.onWindowMessage);
    }, BuilderContent.prototype.subscribeToContent = function () {
      var e = this;
      "_inline" !== this.name && this.subscriptions.add(builder.queueGetContent(this.name, this.options).subscribe(function (t) {
        var n = t && t[0];
        e.setState({
          data: n,
          loading: !1
        });
        var i = (builder.editingModel || builder.previewingModel) === e.name;
        if (!e.props.inline && e.props.content && e.firstLoad && i && (e.firstLoad = !1, e.subscriptions.unsubscribe(), e.subscribeToContent()), n && e.firstLoad && (e.firstLoad = !1, builder.autoTrack && !Builder.isEditing)) {
          var r = !1;
          if ("function" == typeof IntersectionObserver && e.ref) try {
            (e.intersectionObserver = new IntersectionObserver(function (t, i) {
              t.forEach(function (t) {
                t.intersectionRatio > 0 && !e.trackedImpression && (e.builder.trackImpression(n.id, e.renderedVariantId, void 0, {
                  content: e.data
                }), e.data, e.trackedImpression = !0, e.ref && i.unobserve(e.ref));
              });
            })).observe(e.ref), r = !0;
          } catch (e) {
            console.warn("Could not bind intersection observer");
          }
          r || (e.trackedImpression = !0, e.builder.trackImpression(n.id, e.renderedVariantId, void 0, {
            content: n
          }));
        }
        e.props.contentLoaded && e.props.contentLoaded(n && n.data, n);
      }, function (t) {
        e.props.contentError && (e.props.contentError(t), e.setState({
          loading: !1
        }));
      }));
    }, BuilderContent.prototype.componentWillUnmount = function () {
      Builder.isEditing && removeEventListener("message", this.onWindowMessage), this.subscriptions.unsubscribe(), this.intersectionObserver && this.ref && this.intersectionObserver.unobserve(this.ref);
    }, BuilderContent.prototype.render = function () {
      var e = this;
      if (this.props.dataOnly) return null;
      var t = this.state.loading,
        n = this.data,
        i = this.props.dataOnly ? NoWrap : "div";
      return React__default.createElement(VariantsProvider, {
        initialContent: n
      }, function (r, o) {
        return React__default.createElement(React__default.Fragment, null, r.map(function (a, s) {
          var l = s === r.length - 1 ? React__default.Fragment : "template";
          return React__default.createElement(React__default.Fragment, {
            key: String((null == a ? void 0 : a.id) + s)
          }, "template" !== l && (null == o ? void 0 : o()), React__default.createElement(l, _assign({
            key: String((null == a ? void 0 : a.id) + s)
          }, "template" === l && {
            "data-template-variant-id": null == a ? void 0 : a.id
          }), React__default.createElement(i, _assign({}, 0 === s && !e.props.dataOnly && {
            ref: function ref(t) {
              return e.ref = t;
            }
          }, {
            className: "builder-content",
            onClick: e.onClick,
            "builder-content-id": null == a ? void 0 : a.id,
            "builder-model": e.name
          }), e.props.children(null == a ? void 0 : a.data, !e.props.inline && t, n))));
        }));
      });
    }, BuilderContent;
  }(React__default.Component),
  getContentWithInfo = function getContentWithInfo(e) {
    var t;
    if (e) {
      var n = builder.getCookie("builder.tests.".concat(e.id)),
        i = n === e.id ? e : null === (t = e.variations) || void 0 === t ? void 0 : t[n],
        r = (null == i ? void 0 : i.name) || ((null == i ? void 0 : i.id) === e.id ? "Default variation" : "");
      return _assign(_assign({}, e), {
        variationId: n,
        testVariationId: n,
        testVariationName: r
      });
    }
    return null;
  };
function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var onChange_1 = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = Symbol("target"),
      i = Symbol("unsubscribe"),
      r = function r(e, t) {
        return t && t.toString && (e && (e += "."), e += t.toString()), e;
      },
      o = function o(e) {
        return Array.isArray(e) ? e.slice() : Object.assign({}, e);
      },
      a = function a(e, t, _a2) {
        if ("undefined" == typeof Proxy) return e;
        void 0 === _a2 && (_a2 = {});
        var s,
          l,
          u = Symbol("ProxyTarget"),
          d = !1,
          c = !1,
          p = !1,
          f = _a2.equals || Object.is,
          m = new WeakMap(),
          h = new WeakMap(),
          g = new WeakMap(),
          v = function v(e, n, i, a) {
            if (!p) if (d) {
              if (d && l && void 0 !== i && void 0 !== a && "length" !== n) {
                var u = l;
                e !== s && function (e, t) {
                  for (var n; e;) -1 === (n = e.indexOf(".")) && (n = e.length), t(e.slice(0, n)), e = e.slice(n + 1);
                }(e = e.replace(s, "").slice(1), function (e) {
                  u[e] = o(u[e]), u = u[e];
                }), u[n] = i;
              }
              c = !0;
            } else t(r(e, n), a, i);
          },
          b = function b(e, t) {
            var n = m ? m.get(e) : void 0;
            n && n.delete(t);
          },
          y = function y(e, t) {
            if (p) return e;
            h.set(e, t);
            var n = g.get(e);
            return void 0 === n && (n = new Proxy(e, x), g.set(e, n)), n;
          },
          _ = function _(e) {
            return p || !0 === _a2.ignoreSymbols && "symbol" == typeof e;
          },
          x = {
            get: function get(e, t, o) {
              if (t === u || t === n) return e;
              if (t === i && "" === h.get(e)) return function (e) {
                return p = !0, m = null, h = null, g = null, e;
              }(e);
              var s = Reflect.get(e, t, o);
              if (function (e) {
                return null === e || "object" != typeof e && "function" != typeof e;
              }(s) || function (e) {
                return e instanceof RegExp || e instanceof Number;
              }(s) || "constructor" === t || !0 === _a2.isShallow) return s;
              var l = function (e, t) {
                var n = m ? m.get(e) : void 0;
                if (n) return n;
                n = new Map(), m.set(e, n);
                var i = n.get(t);
                return i || (i = Reflect.getOwnPropertyDescriptor(e, t), n.set(t, i)), i;
              }(e, t);
              if (l && !l.configurable) {
                if (l.set && !l.get) return;
                if (!1 === l.writable) return s;
              }
              return y(s, r(h.get(e), t));
            },
            set: function set(e, t, n, i) {
              n && void 0 !== n[u] && (n = n[u]);
              var r = _(t),
                o = r ? null : Reflect.get(e, t, i),
                a = Reflect.set(e[u] || e, t, n);
              return r || f(o, n) || v(h.get(e), t, o, n), a;
            },
            defineProperty: function defineProperty(e, t, n) {
              var i = Reflect.defineProperty(e, t, n);
              return _(t) || (b(e, t), v(h.get(e), t, void 0, n.value)), i;
            },
            deleteProperty: function deleteProperty(e, t) {
              if (!Reflect.has(e, t)) return !0;
              var n = _(t),
                i = n ? null : Reflect.get(e, t),
                r = Reflect.deleteProperty(e, t);
              return n || (b(e, t), v(h.get(e), t, i)), r;
            },
            apply: function apply(e, t, n) {
              var i = t instanceof Date;
              if (i && (t = t[u]), !d) {
                d = !0, i && (l = t.valueOf()), (Array.isArray(t) || "[object Object]" === toString.call(t)) && (l = o(t[u])), s = (s = h.get(e)).slice(0, Math.max(s.lastIndexOf("."), 0));
                var r = Reflect.apply(e, t, n);
                return d = !1, (c || i && !f(l, t.valueOf())) && (v(s, "", l, t[u] || t), l = null, c = !1), r;
              }
              return Reflect.apply(e, t, n);
            }
          },
          S = y(e, "");
        return t = t.bind(S), S;
      };
    a.target = function (e) {
      return e[n] || e;
    }, a.unsubscribe = function (e) {
      return e[i] || e;
    }, e.exports = a, t.default = a;
  }),
  onChange = unwrapExports(onChange_1),
  nextTick = Builder.nextTick;
function debounceNextTick(e, t, n) {
  return void 0 === t && "function" == typeof e ? debounceNextTickImpl(e) : {
    configurable: !0,
    enumerable: n.enumerable,
    get: function get() {
      return Object.defineProperty(this, t, {
        configurable: !0,
        enumerable: n.enumerable,
        value: debounceNextTickImpl(n.value)
      }), this[t];
    }
  };
}
function debounceNextTickImpl(e) {
  var t = null,
    n = null;
  return function () {
    var e = t;
    if (t = [].slice.call(arguments), n = this, null !== e) return;
    nextTick(i);
  };
  function i() {
    e.apply(n, t), t = null, n = null;
  }
}
function throttle(e, t, n) {
  var i, r, o;
  void 0 === n && (n = {});
  var a = null,
    s = 0,
    l = function l() {
      s = !1 === n.leading ? 0 : Date.now(), a = null, o = e.apply(i, r), a || (i = r = null);
    };
  return function () {
    var u = Date.now();
    s || !1 !== n.leading || (s = u);
    var d = t - (u - s);
    return i = this, r = arguments, d <= 0 || d > t ? (a && (clearTimeout(a), a = null), s = u, o = e.apply(i, r), a || (i = r = null)) : a || !1 === n.trailing || (a = setTimeout(l, d)), o;
  };
}
var BuilderMetaContext = React__default.createContext({
    emailMode: !1,
    ampMode: !1,
    isServer: !1
  }),
  tryEval = function tryEval(e, t, n) {
    var i;
    void 0 === t && (t = {});
    var r = e;
    if ("string" == typeof r && r.trim()) {
      var o = !(r.includes(";") || r.includes(" return ")),
        a = function a() {};
      try {
        Builder.isBrowser && (a = new Function("state", "var rootState = state;\n        if (typeof Proxy !== 'undefined') {\n          rootState = new Proxy(rootState, {\n            set: function () {\n              return false;\n            },\n            get: function (target, key) {\n              if (key === 'state') {\n                return state;\n              }\n              return target[key]\n            }\n          });\n        }\n        with (rootState) {\n          ".concat(o ? "return (".concat(e, ");") : e, ";\n        }")));
      } catch (e) {
        Builder.isBrowser && console.warn("Could not compile javascript", e);
      }
      try {
        return Builder.isBrowser ? a(t || {}) : new (0, safeDynamicRequire("vm2").VM)({
          sandbox: _assign(_assign({}, t), {
            state: t
          })
        }).run(r.replace(/(^|;)return /, "$1"));
      } catch (t) {
        n && n.push(t), Builder.isBrowser ? console.warn("Builder custom code error:", t.message, "in", e, t.stack) : (null === (i = null === process || void 0 === process ? void 0 : process.env) || void 0 === i ? void 0 : i.DEBUG) && console.debug("Builder custom code error:", t.message, "in", e, t.stack);
      }
    }
  };
function toError(e) {
  return e instanceof Error ? e : new Error(String(e));
}
function getBuilderPixel(e) {
  return {
    id: "builder-pixel-" + Math.random().toString(36).split(".")[1],
    "@type": "@builder.io/sdk:Element",
    tagName: "img",
    properties: {
      role: "presentation",
      "aria-hidden": "true",
      src: "https://cdn.builder.io/api/v1/pixel?apiKey=".concat(e)
    },
    responsiveStyles: {
      large: {
        height: "0",
        width: "0",
        display: "inline-block",
        opacity: "0",
        overflow: "hidden",
        pointerEvents: "none"
      }
    }
  };
}
function pick(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  var i = {};
  return t.forEach(function (t) {
    i[t] = e[t];
  }), i;
}
function omit(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  var i = _assign({}, e);
  return t.forEach(function (e) {
    delete i[e];
  }), i;
}
var wrapComponent = function wrapComponent(e) {
    return function (t) {
      var n,
        i = t.builderTag || "div",
        r = ["children"].concat((null === (n = e.inputs) || void 0 === n ? void 0 : n.map(function (e) {
          return e.name;
        })) || []),
        o = omit.apply(void 0, __spreadArray(__spreadArray([t], r, !1), ["attributes"], !1)),
        a = t;
      return e.noWrap ? React__default.createElement(e.class, _assign({
        attributes: o
      }, a)) : React__default.createElement(i, _assign({}, o), React__default.createElement(e.class, _assign({}, a)));
    };
  },
  size$1 = function size$1(e) {
    return Object.keys(e).length;
  };
function debounce(e, t, n) {
  var i;
  return void 0 === n && (n = !1), function () {
    var r = this,
      o = arguments;
    clearTimeout(i), i = setTimeout(function () {
      i = null, n || e.apply(r, o);
    }, t), n && !i && e.apply(r, o);
  };
}
var fontsLoaded = new Set(),
  fetch$1;
globalThis.fetch && (fetch$1 = globalThis.fetch), null != fetch$1 || (fetch$1 = require("node-fetch"));
var sizeMap = {
    desktop: "large",
    tablet: "medium",
    mobile: "small"
  },
  fetchCache = {};
function searchToObject$1(e) {
  var t = (e.search || "").substring(1).split("&"),
    n = {};
  for (var i in t) if (t[i] && "string" == typeof t[i]) {
    var r = t[i].split("=");
    n[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
  }
  return n;
}
var BuilderComponent = function (e) {
  function t(t) {
    var n,
      i = this;
    (i = e.call(this, t) || this).subscriptions = new Subscription(), i.onStateChange = new BehaviorSubject(null), i.asServer = Builder.isServer, i.contentRef = null, i.styleRef = null, i.rootState = Builder.isServer ? {} : onChange({}, function () {
      return i.updateState();
    }), i.lastJsCode = "", i.lastHttpRequests = {}, i.httpSubscriptionPerKey = {}, i.firstLoad = !0, i.ref = null, i.messageListener = function (e) {
      var t,
        n = e.data;
      switch (n.type) {
        case "builder.configureSdk":
          var r = n.data;
          if (!r.contentId || r.contentId !== (null === (t = i.useContent) || void 0 === t ? void 0 : t.id)) return;
          i.sizes = getSizesForBreakpoints(r.breakpoints || {}), i.setState({
            state: Object.assign(i.rootState, {
              deviceSize: i.deviceSizeState,
              device: i.device
            }),
            updates: (i.state && i.state.updates || 0) + 1,
            breakpoints: r.breakpoints
          });
          break;
        case "builder.updateSpacer":
          var o = n.data;
          i.rootState._spacer, i.updateState(function (e) {
            e._spacer = o;
          });
          break;
        case "builder.resetState":
          var a = n.data,
            s = a.state;
          if (a.model === i.name) {
            for (var l in i.rootState) "function" != typeof i.rootState[l] && delete i.rootState[l];
            Object.assign(i.rootState, s), i.setState(_assign(_assign({}, i.state), {
              state: i.rootState,
              updates: (i.state && i.state.updates || 0) + 1
            }));
          }
          break;
        case "builder.resetSymbolState":
          var u = n.data.state,
            d = (s = u.state, u.model, u.id);
          if (i.props.builderBlock && i.props.builderBlock === d) {
            for (var l in i.rootState) delete i.rootState[l];
            Object.assign(i.rootState, s), i.setState(_assign(_assign({}, i.state), {
              state: i.rootState,
              updates: (i.state && i.state.updates || 0) + 1
            }));
          }
      }
    }, i.resizeFn = function () {
      var e = i.deviceSizeState;
      e !== i.state.state.deviceSize && i.setState(_assign(_assign({}, i.state), {
        updates: (i.state && i.state.updates || 0) + 1,
        state: Object.assign(i.rootState, _assign(_assign({}, i.state.state), {
          deviceSize: e
        }))
      }));
    }, i.resizeListener = Builder.isEditing ? throttle(i.resizeFn, 200) : debounce(i.resizeFn, 400), i.mounted = !1, i.updateState = function (e) {
      var t = i.rootState;
      e && e(t), i.mounted ? i.setState({
        update: i.updateState,
        state: t,
        updates: (i.state && i.state.updates || 0) + 1
      }) : i.state = _assign(_assign({}, i.state), {
        update: i.updateState,
        state: t,
        updates: (i.state && i.state.updates || 0) + 1
      }), i.notifyStateChange();
    }, i.onContentLoaded = function (e, t) {
      var n;
      if ("page" === i.name && Builder.isBrowser && e) {
        var r = e.title,
          o = e.pageTitle,
          a = e.description,
          s = e.pageDescription;
        if ((r || o) && (document.title = r || o), a || s) {
          var l = document.querySelector('meta[name="description"]');
          l || ((l = document.createElement("meta")).setAttribute("name", "description"), document.head.appendChild(l)), l.setAttribute("content", a || s);
        }
      }
      if (Builder.isEditing && i.notifyStateChange(), i.props.contentLoaded && i.props.contentLoaded(e, t), e && e.inputs && Array.isArray(e.inputs) && e.inputs.length && (e.state || (e.state = {}), e.inputs.forEach(function (t) {
        t && t.name && void 0 !== t.defaultValue && void 0 === e.state[t.name] && (e.state[t.name] = t.defaultValue);
      })), e && e.state) {
        var u = _assign(_assign({}, i.state), {
          updates: (i.state && i.state.updates || 0) + 1,
          state: Object.assign(i.rootState, _assign(_assign(_assign(_assign({}, i.state.state), {
            location: i.locationState,
            deviceSize: i.deviceSizeState,
            device: i.device
          }), e.state), i.externalState))
        });
        i.mounted ? i.setState(u) : i.state = u;
      }
      if (e && e.jsCode && Builder.isBrowser && !i.options.codegen) {
        var d = !1;
        if (Builder.isEditing && (i.lastJsCode === e.jsCode ? d = !0 : i.lastJsCode = e.jsCode), !d) {
          var c = i.state.state;
          try {
            new Function("data", "ref", "state", "update", "element", "Builder", "builder", "context", e.jsCode)(e, i, c, i.state.update, i.ref, Builder, builder, i.state.context);
          } catch (t) {
            var p = toError(t);
            Builder.isBrowser ? console.warn("Builder custom code error:", p.message, "in", e.jsCode, p.stack) : (null === (n = null === process || void 0 === process ? void 0 : process.env) || void 0 === n ? void 0 : n.DEBUG) && console.debug("Builder custom code error:", p.message, "in", e.jsCode, p.stack);
          }
        }
      }
      if (e && e.httpRequests && !i.props.noAsync && !(d = !1)) {
        var f = function f(t) {
          var n = e.httpRequests[t];
          if (n && (!i.data[t] || Builder.isEditing)) if (Builder.isBrowser) {
            var r = i.evalExpression(n);
            if (Builder.isEditing && i.lastHttpRequests[t] === r) return "continue";
            i.lastHttpRequests[t] = r;
            var o = n.match(/builder\.io\/api\/v2\/([^\/\?]+)/i);
            o && o[1], i.handleRequest(t, r);
            var a = i.httpSubscriptionPerKey[t];
            a && a.unsubscribe();
            var s = i.httpSubscriptionPerKey[t] = i.onStateChange.subscribe(function () {
              var e = i.evalExpression(n);
              e !== r && (i.handleRequest(t, e), i.lastHttpRequests[t] = e);
            });
            i.subscriptions.add(s);
          } else i.handleRequest(t, i.evalExpression(n));
        };
        for (var m in e.httpRequests) f(m);
      }
    };
    var r = i.inlinedContent;
    if (r && r.content && (r = r.content), i.sizes = getSizesForBreakpoints((null === (n = null == r ? void 0 : r.meta) || void 0 === n ? void 0 : n.breakpoints) || {}), i.state = {
      context: _assign(_assign({}, t.context), {
        apiKey: builder.apiKey || i.props.apiKey
      }),
      state: Object.assign(i.rootState, _assign(_assign(_assign(_assign({}, i.inlinedContent && i.inlinedContent.data && i.inlinedContent.data.state), {
        isBrowser: Builder.isBrowser,
        isServer: !Builder.isBrowser,
        _hydrate: t.hydrate,
        location: i.locationState,
        deviceSize: i.deviceSizeState,
        device: i.device
      }), i.getHtmlData()), t.data)),
      updates: 0,
      key: 0,
      update: i.updateState
    }, Builder.isBrowser) {
      var o = i.props.apiKey;
      if (o && o !== i.builder.apiKey && (i.builder.apiKey = o), i.inlinedContent) {
        var a = i.inlinedContent.content || i.inlinedContent;
        i.onContentLoaded(null == a ? void 0 : a.data, getContentWithInfo(a));
      }
    }
    return i;
  }
  return __extends(t, e), Object.defineProperty(t.prototype, "options", {
    get: function get() {
      return _assign(_assign({}, t.defaults), this.props);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "name", {
    get: function get() {
      return this.props.model || this.props.modelName || this.props.name;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "element", {
    get: function get() {
      return this.ref;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "inlinedContent", {
    get: function get() {
      if (!this.isPreviewing || this.props.inlineContent) return this.props.content;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "builder", {
    get: function get() {
      return this.props.builder || builder;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getHtmlData = function () {
    var e = this.inlinedContent && this.inlinedContent.id || this.props.entry,
      t = e && Builder.isBrowser && document.querySelector('script[data-builder-json="'.concat(e, '"],script[data-builder-state="').concat(e, '"]'));
    if (t) try {
      return JSON.parse(t.innerText);
    } catch (e) {
      console.warn("Could not parse Builder.io HTML data transfer", e, t.innerText);
    }
    return {};
  }, Object.defineProperty(t.prototype, "device", {
    get: function get() {
      return this.builder.getUserAttributes().device || "desktop";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "locationState", {
    get: function get() {
      return _assign(_assign({}, pick(this.location, "pathname", "hostname", "search", "host")), {
        path: this.location.pathname && this.location.pathname.split("/").slice(1) || "",
        query: searchToObject$1(this.location)
      });
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "deviceSizeState", {
    get: function get() {
      return Builder.isBrowser ? this.sizes.getSizeForWidth(window.innerWidth) : sizeMap[this.device] || "large";
    },
    enumerable: !1,
    configurable: !0
  }), t.renderInto = function (e, n, i, r) {
    if (void 0 === n && (n = {}), void 0 === i && (i = !0), void 0 === r && (r = !1), console.debug("BuilderPage.renderInto", e, n, i, this), e) {
      var o = null;
      if ("string" == typeof e ? o = document.querySelector(e) : e instanceof Element && (o = e), o) {
        var a = o.classList.contains("builder-hydrated");
        if (!a || r) {
          o.classList.add("builder-hydrated");
          var s = i && o.innerHTML.includes("builder-block");
          if (!o.classList.contains("builder-component")) {
            var l = o.querySelector(".builder-api-styles") || (o.previousElementSibling && o.previousElementSibling.matches(".builder-api-styles") ? o.previousElementSibling : null),
              u = "";
            if (l) l.innerHTML.replace(/\/\*start:([^\*]+?)\*\/([\s\S]*?)\/\*end:([^\*]+?)\*\//g, function (e, t, n) {
              var i = null;
              try {
                i = document.querySelector('[data-emotion-css="'.concat(t, '"]'));
              } catch (e) {
                console.warn(e);
              }
              return i ? i.innerHTML = n : Builder.isEditing || (u += e), e;
            }), Builder.nextTick(function () {
              l.innerHTML = u;
            });
            var d = o.querySelector(".builder-component");
            d ? o = d : s = !1;
          }
          location.search.includes("builder.debug=true") && console.debug("hydrate", s, o);
          var c = o;
          if (!a) {
            var p = document.createElement("div");
            o.insertAdjacentElement("beforebegin", p), p.appendChild(o), c = p;
          }
          if ((Builder.isEditing || Builder.isBrowser && location.search.includes("builder.preview=")) && (s = !1), s && o) {
            var f = ReactDOM.render(React__default.createElement(t, _assign({}, n)), c, c.builderRootRef);
            return c.builderRootRef = f, f;
          }
          var m = ReactDOM.render(React__default.createElement(t, _assign({}, n)), c, c.builderRootRef);
          return c.builderRootRef = m, m;
        }
        console.debug("Tried to hydrate multiple times");
      }
    }
  }, t.prototype.componentDidMount = function () {
    var e,
      t = this;
    this.mounted = !0, this.asServer && (this.asServer = !1, this.updateState(function (e) {
      e.isBrowser = !0, e.isServer = !1;
    })), Builder.isIframe && (null === (e = window.parent) || void 0 === e || e.postMessage({
      type: "builder.sdkInjected",
      data: {
        modelName: this.name
      }
    }, "*")), Builder.isBrowser && (window.addEventListener("resize", this.resizeListener), Builder.isEditing && window.addEventListener("message", this.messageListener), (Builder.isEditing || Builder.isPreviewing) && Builder.nextTick(function () {
      t.firstLoad = !1, t.reload();
    }), setTimeout(function () {
      window.dispatchEvent(new CustomEvent("builder:component:load", {
        detail: {
          ref: t
        }
      }));
    }));
  }, Object.defineProperty(t.prototype, "isPreviewing", {
    get: function get() {
      return (Builder.isServer || Builder.isBrowser && Builder.isPreviewing && !this.firstLoad) && builder.previewingModel === this.name;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.notifyStateChange = function () {
    if (!Builder.isServer && this && this.state) {
      var e = this.state.state;
      this.props.onStateChange && this.props.onStateChange(e), Builder.isBrowser && window.dispatchEvent(new CustomEvent("builder:component:stateChange", {
        detail: {
          state: e,
          ref: this
        }
      })), this.onStateChange.next(e);
    }
  }, t.prototype.processStateFromApi = function (e) {
    return e;
  }, Object.defineProperty(t.prototype, "location", {
    get: function get() {
      return this.props.location || (Builder.isBrowser ? location : {});
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getCssFromFont = function (e, t) {
    var n = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""),
      i = n.split(",")[0],
      r = e.fileUrl ? e.fileUrl : e.files && e.files.regular,
      o = "";
    if (r && n && i && (o += '\n@font-face {\n  font-family: "'.concat(n, '";\n  src: local("').concat(i, "\"), url('").concat(r, "') format('woff2');\n  font-display: fallback;\n  font-weight: 400;\n}\n        ").trim()), e.files) for (var a in e.files) {
      if (String(Number(a)) === a) {
        var s = e.files[a];
        s && s !== r && (o += '\n@font-face {\n  font-family: "'.concat(n, "\";\n  src: url('").concat(s, "') format('woff2');\n  font-display: fallback;\n  font-weight: ").concat(a, ";\n}\n          ").trim());
      }
    }
    return o;
  }, t.prototype.componentWillUnmount = function () {
    this.unsubscribe(), Builder.isBrowser && (window.removeEventListener("resize", this.resizeListener), window.removeEventListener("message", this.messageListener));
  }, t.prototype.getFontCss = function (e) {
    var t = this;
    return this.builder.allowCustomFonts && (null == e ? void 0 : e.customFonts) && e.customFonts.length && e.customFonts.map(function (n) {
      return t.getCssFromFont(n, e);
    }).join(" ") || "";
  }, t.prototype.ensureFontsLoaded = function (e) {
    if (this.builder.allowCustomFonts && (null == e ? void 0 : e.customFonts) && Array.isArray(e.customFonts)) for (var t = 0, n = e.customFonts; t < n.length; t++) {
      var i = n[t],
        r = i.fileUrl ? i.fileUrl : i.files && i.files.regular;
      if (!fontsLoaded.has(r)) {
        var o = this.getCssFromFont(i, e);
        if (fontsLoaded.add(r), !o) continue;
        var a = document.createElement("style");
        a.className = "builder-custom-font", a.setAttribute("data-builder-custom-font", r), a.innerHTML = o, document.head.appendChild(a);
      }
    }
  }, t.prototype.getCss = function (e) {
    var t,
      n = null === (t = this.useContent) || void 0 === t ? void 0 : t.id,
      i = (null == e ? void 0 : e.cssCode) || "";
    return n && (i = i.replace(/&/g, ".builder-component-".concat(n))), i + this.getFontCss(e);
  }, Object.defineProperty(t.prototype, "data", {
    get: function get() {
      var e,
        t = _assign(_assign(_assign({}, this.inlinedContent && (null === (e = this.inlinedContent.data) || void 0 === e ? void 0 : e.state)), this.externalState), this.state.state);
      return Object.assign(this.rootState, t), t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.componentDidUpdate = function (e) {
    var t = this;
    this.props.data && e.data !== this.props.data && this.state.update(function (e) {
      Object.assign(e, t.externalState);
    }), Builder.isEditing && this.inlinedContent && e.content !== this.inlinedContent && this.onContentLoaded(this.inlinedContent.data, this.inlinedContent);
  }, t.prototype.checkStyles = function (e) {
    if (this.styleRef) {
      var t = this.getCss(e);
      this.styleRef.innerHTML !== t && (this.styleRef.innerHTML = t);
    }
  }, t.prototype.reload = function () {
    this.setState({
      key: this.state.key + 1
    });
  }, Object.defineProperty(t.prototype, "content", {
    get: function get() {
      var e = this.inlinedContent;
      return e && e.content && (e = _assign(_assign({}, e), {
        data: e.content
      })), e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "externalState", {
    get: function get() {
      return _assign(_assign({}, this.props.data), this.props.locale ? {
        locale: this.props.locale
      } : {});
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "useContent", {
    get: function get() {
      return this.content || this.state.context.builderContent;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.render = function () {
    var e,
      t = this,
      n = this.content,
      i = Builder.isBrowser && this.externalState && size$1(this.externalState) && hash(this.externalState),
      r = Builder.isEditing ? this.name : this.props.entry;
    r && !Builder.isEditing && i && i.length < 300 && (r += ":" + i);
    var o = this.props.dataOnly ? React__default.Fragment : "div",
      a = null === (e = this.useContent) || void 0 === e ? void 0 : e.id;
    return React__default.createElement(o, {
      onClick: function onClick(e) {
        !Builder.isEditing || t.props.isChild || t.props.stopClickPropagationWhenEditing || e.stopPropagation();
      },
      className: "builder-component ".concat(a ? "builder-component-".concat(a) : ""),
      "data-name": this.name,
      "data-source": "Rendered by Builder.io",
      key: this.state.key,
      ref: function ref(e) {
        return t.ref = e;
      }
    }, React__default.createElement(BuilderMetaContext.Consumer, null, function (e) {
      return React__default.createElement(BuilderMetaContext.Provider, {
        value: "boolean" == typeof t.props.ampMode ? _assign(_assign({}, e), {
          ampMode: t.props.ampMode
        }) : e
      }, React__default.createElement(BuilderAsyncRequestsContext.Consumer, null, function (e) {
        var i;
        return t._asyncRequests = e && e.requests, t._errors = e && e.errors, t._logs = e && e.logs, React__default.createElement(BuilderContent, {
          isStatic: t.props.isStatic || Builder.isStatic,
          key: (null === (i = t.inlinedContent) || void 0 === i ? void 0 : i.id) || ("content" in t.props && !t.isPreviewing ? "null-content-prop" : "no-content-prop"),
          builder: t.builder,
          ref: function ref(e) {
            return t.contentRef = e;
          },
          contentLoaded: function contentLoaded(e, n) {
            return t.onContentLoaded(e, n);
          },
          options: _assign(_assign(_assign(_assign(_assign(_assign({
            key: r,
            entry: t.props.entry
          }, n && {
            initialContent: [n]
          }), !n && "content" in t.props && !t.isPreviewing && {
            initialContent: []
          }), t.props.url && {
            url: t.props.url
          }), t.props.options), t.props.locale ? {
            locale: t.props.locale
          } : {}), t.options.codegen && {
            format: "react"
          }),
          inline: t.props.inlineContent || !t.isPreviewing && "content" in t.props,
          contentError: t.props.contentError,
          modelName: t.name || "page"
        }, function (e, n, i) {
          var r;
          if (t.props.dataOnly) return null;
          i && i.id && (t.state.breakpoints && (i.meta = i.meta || {}, i.meta.breakpoints = t.state.breakpoints), t.state.context.builderContent = i), Builder.isBrowser && Builder.nextTick(function () {
            t.checkStyles(e);
          });
          var o = t.options.codegen;
          if (o && !t.Component && (null == e ? void 0 : e.blocksJs)) {
            var a = Array.from(new Set(Builder.components.map(function (e) {
                return e.name;
              }))),
              s = Builder.components.slice().reverse(),
              l = a.map(function (e) {
                return s.find(function (t) {
                  return t.class && t.name === e;
                });
              }),
              u = a.map(function (e) {
                return (e || "").replace(/[^\w]+/gi, "");
              }),
              d = l.map(function (e) {
                return wrapComponent(e);
              });
            t.Component = new (Function.bind.apply(Function, __spreadArray(__spreadArray([void 0, "jsx", "_css", "Builder", "builder", "React", "useBuilderState"], u, !1), [e.blocksJs], !1)))().apply(void 0, __spreadArray([jsx, css, Builder, builder, React__default, function (e) {
              var t = React__default.useState(0)[1];
              return React__default.useState(function () {
                return onChange(e, function () {
                  t(function (e) {
                    return e + 1;
                  });
                });
              })[0];
            }], d, !1));
          }
          var c = (null == e ? void 0 : e.blocks) || [],
            p = c.find(function (e) {
              var t;
              return null === (t = e.id) || void 0 === t ? void 0 : t.startsWith("builder-pixel");
            });
          return e && !p && c.length > 0 && c.push(getBuilderPixel(builder.apiKey)), e ? React__default.createElement("div", _assign({
            "data-builder-component": t.name,
            "data-builder-content-id": i.id
          }, t.isPreviewing ? {
            "data-builder-variation-id": i.testVariationId || i.variationId || i.id
          } : {}), !o && t.getCss(e) && React__default.createElement("style", {
            ref: function ref(e) {
              return t.styleRef = e;
            },
            className: "builder-custom-styles",
            dangerouslySetInnerHTML: {
              __html: t.getCss(e)
            }
          }), React__default.createElement(BuilderStoreContext.Provider, {
            value: _assign(_assign({}, t.state), {
              rootState: t.rootState,
              state: t.data,
              content: i,
              renderLink: t.props.renderLink
            })
          }, o && t.Component ? React__default.createElement(t.Component, {
            data: t.data,
            context: t.state.context
          }) : React__default.createElement(BuilderBlocks, {
            key: String(!!(null === (r = null == e ? void 0 : e.blocks) || void 0 === r ? void 0 : r.length)),
            emailMode: t.props.emailMode,
            fieldName: "blocks",
            blocks: c
          }))) : n ? React__default.createElement("div", {
            "data-builder-component": t.name,
            className: "builder-loading"
          }, t.props.children) : React__default.createElement("div", {
            "data-builder-component": t.name,
            className: "builder-no-content"
          });
        });
      }));
    }));
  }, t.prototype.evalExpression = function (e) {
    var t = this,
      n = this.data;
    return String(e).replace(/{{([^}]+)}}/g, function (e, i) {
      return tryEval(i, n, t._errors);
    });
  }, t.prototype.handleRequest = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n,
        i,
        r,
        o,
        a = this;
      return __generator(this, function (s) {
        return Builder.isIframe && fetchCache[t] ? (this.updateState(function (n) {
          n[e] = fetchCache[t];
        }), [2, fetchCache[t]]) : (n = function n() {
          return __awaiter(a, void 0, void 0, function () {
            var n, i, r, o;
            return __generator(this, function (a) {
              switch (a.label) {
                case 0:
                  n = Date.now(), Builder.isBrowser || console.time("Fetch " + t), a.label = 1;
                case 1:
                  return a.trys.push([1, 4, 5, 6]), [4, fetch$1(t)];
                case 2:
                  return [4, a.sent().json()];
                case 3:
                  return i = a.sent(), [3, 6];
                case 4:
                  return r = a.sent(), o = toError(r), this._errors && this._errors.push(o), this._logs && this._logs.push("Fetch to ".concat(t, " errored in ").concat(Date.now() - n, "ms")), [2];
                case 5:
                  return Builder.isBrowser || (console.timeEnd("Fetch " + t), this._logs && this._logs.push("Fetched ".concat(t, " in ").concat(Date.now() - n, "ms"))), [7];
                case 6:
                  return i && (Builder.isIframe && (fetchCache[t] = i), this.updateState(function (t) {
                    t[e] = i;
                  })), [2, i];
              }
            });
          });
        }, (i = this._asyncRequests && this._asyncRequests.find(function (e) {
          return isRequestInfo(e) && e.url === t;
        })) ? ((r = i.promise).then(function (t) {
          t && a.updateState(function (n) {
            n[e] = t;
          });
        }), [2, r]) : (o = n(), Builder.nextTick(function () {
          a._asyncRequests && a._asyncRequests.push(o);
        }), [2, o]));
      });
    });
  }, t.prototype.unsubscribe = function () {
    this.subscriptions && (this.subscriptions.unsubscribe(), this.subscriptions = new Subscription());
  }, t.prototype.handleBuilderRequest = function (e, t) {
    var n = this,
      i = tryEval(t, this.data, this._errors);
    this.subscriptions && this.unsubscribe(), i && this.subscriptions.add(this.builder.queueGetContent(i.model, i).subscribe(function (t) {
      t && n.updateState(function (n) {
        n[e] = t;
      });
    }));
  }, t.defaults = {
    codegen: Boolean(Builder.isBrowser && location.href.includes("builder.codegen=true"))
  }, __decorate([debounceNextTick, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], t.prototype, "notifyStateChange", null), t;
}(React__default.Component);
function BuilderBlock(e) {
  return e.type = "react", Builder.Component(e);
}
function updateMetadata(e, t) {
  var n = Builder.components.find(function (t) {
      return "string" == typeof e ? t.name === e : t.class === t;
    }) || null,
    i = t(n);
  n && i ? Builder.registerComponent(i.class || n.class, i) : n && !i || !n && i && Builder.registerComponent(i.class, i);
}
function withBuilder(e, t) {
  return BuilderBlock(t)(e), e;
}
var withChildren = function withChildren(e) {
    var t = React__default.forwardRef(function (t, n) {
      var i = t.children || t.builderBlock && t.builderBlock.children && t.builderBlock.children.map(function (e) {
        return React__default.createElement(BuilderBlock$1, {
          key: e.id,
          block: e
        });
      });
      return React__default.createElement(e, _assign({}, t, {
        ref: n
      }), i);
    });
    return t.builderOptions = {
      canHaveChildren: !0
    }, t;
  },
  noWrap = function noWrap(e) {
    var t = React__default.forwardRef(function (t, n) {
      var i = _assign(_assign({}, t), t.attributes);
      return React__default.createElement(e, _assign({}, i, {
        ref: n
      }));
    });
    return t.builderOptions = {
      noWrap: !0
    }, t;
  },
  iconUrl = "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  TextComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.textRef = null, t;
    }
    return __extends(t, e), t.prototype.componentDidUpdate = function (e) {
      this.allowTextEdit && (!this.textRef || "true" === this.textRef.contentEditable && this.textRef === document.activeElement || this.props.text !== e.text && (this.textRef.innerHTML = this.props.text));
    }, t.prototype.componentDidMount = function () {
      this.textRef && (this.textRef.innerHTML = this.props.text);
    }, t.prototype.evalExpression = function (e, t) {
      return String(e).replace(/{{([^}]+)}}/g, function (e, n) {
        return tryEval(n, t);
      });
    }, Object.defineProperty(t.prototype, "allowTextEdit", {
      get: function get() {
        return Builder.isBrowser && Builder.isEditing && location.search.includes("builder.allowTextEdit=true") && !(this.props.builderBlock && this.props.builderBlock.bindings && (this.props.builderBlock.bindings["component.options.text"] || this.props.builderBlock.bindings["options.text"] || this.props.builderBlock.bindings.text));
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e = this,
        t = this.allowTextEdit,
        n = {
          outline: "none",
          "& p:first-of-type, & .builder-paragraph:first-of-type": {
            margin: 0
          },
          "& > p, & .builder-paragraph": {
            color: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            textAlign: "inherit",
            fontFamily: "inherit"
          }
        };
      return jsx(BuilderStoreContext.Consumer, null, function (i) {
        var r;
        return (null === (r = i.content.meta) || void 0 === r ? void 0 : r.rtlMode) && (n.direction = "rtl"), jsx(React__default.Fragment, null, jsx("span", _assign({
          ref: function ref(t) {
            e.textRef = t;
          },
          contentEditable: t || void 0,
          onInput: function onInput(n) {
            var i;
            t && (null === (i = window.parent) || void 0 === i || i.postMessage({
              type: "builder.textEdited",
              data: {
                id: e.props.builderBlock && e.props.builderBlock.id,
                value: n.currentTarget.innerHTML
              }
            }, "*"));
          },
          onKeyDown: function onKeyDown(n) {
            t && e.textRef && 27 === n.which && document.activeElement === e.textRef && e.textRef.blur();
          },
          onFocus: function onFocus(n) {
            var i;
            t && (null === (i = window.parent) || void 0 === i || i.postMessage({
              type: "builder.textFocused",
              data: {
                id: e.props.builderBlock && e.props.builderBlock.id
              }
            }, "*"));
          },
          onBlur: function onBlur(n) {
            var i;
            t && (null === (i = window.parent) || void 0 === i || i.postMessage({
              type: "builder.textBlurred",
              data: {
                id: e.props.builderBlock && e.props.builderBlock.id
              }
            }, "*"));
          },
          css: n,
          className: "builder-text"
        }, !t && {
          dangerouslySetInnerHTML: {
            __html: e.evalExpression(e.props.text || e.props.content || "", i.state)
          }
        })));
      });
    }, t;
  }(React__default.Component),
  Text = withBuilder(TextComponent, {
    name: "Text",
    static: !0,
    image: iconUrl,
    inputs: [{
      name: "text",
      type: "html",
      required: !0,
      autoFocus: !0,
      bubble: !0,
      defaultValue: "Enter some text..."
    }],
    defaultStyles: {
      lineHeight: "normal",
      height: "auto",
      textAlign: "center"
    }
  });
function Slot(e) {
  var t = e.name,
    n = useContext(BuilderStoreContext),
    i = !n.context.symbolId;
  return jsx("div", _assign({
    css: {
      pointerEvents: "auto"
    }
  }, i && {
    "builder-slot": t
  }), jsx(BuilderBlocks, {
    child: !0,
    parentElementId: n.context.symbolId,
    dataPath: "symbol.data.".concat(t),
    blocks: n.state[t] || []
  }));
}
Builder.registerComponent(Slot, {
  name: "Slot",
  description: "Allow child blocks to be inserted into this content when used as a Symbol",
  docsLink: "https://www.builder.io/c/docs/symbols-with-blocks",
  image: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",
  inputs: [{
    name: "name",
    type: "string",
    required: !0,
    defaultValue: "children"
  }]
});
var FragmentComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      return this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e, t) {
        return React__default.createElement(BuilderBlock$1, {
          block: e,
          key: e.id,
          index: t
        });
      });
    }, t;
  }(React__default.Component),
  Fragment = withBuilder(FragmentComponent, {
    name: "Core:Fragment",
    canHaveChildren: !0,
    noWrap: !0,
    static: !0,
    hideFromInsertMenu: !0
  }),
  DEFAULT_ASPECT_RATIO$2 = .7004048582995948,
  defaultBlocks = [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        flexShrink: "0",
        position: "relative",
        marginTop: "30px",
        textAlign: "center",
        lineHeight: "normal",
        height: "auto",
        minHeight: "20px",
        minWidth: "20px",
        overflow: "hidden"
      }
    },
    component: {
      name: "Image",
      options: {
        image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
        backgroundPosition: "center",
        backgroundSize: "cover",
        aspectRatio: DEFAULT_ASPECT_RATIO$2
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        flexShrink: "0",
        position: "relative",
        marginTop: "30px",
        textAlign: "center",
        lineHeight: "normal",
        height: "auto"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p>Enter some text...</p>"
      }
    }
  }],
  ColumnsComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "columns", {
      get: function get() {
        return this.props.columns || [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "gutterSize", {
      get: function get() {
        return "number" == typeof this.props.space ? this.props.space || 0 : 20;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getWidth = function (e) {
      return this.columns[e] && this.columns[e].width || 100 / this.columns.length;
    }, t.prototype.getColumnWidth = function (e) {
      var t = this.columns,
        n = this.gutterSize * (t.length - 1) / t.length;
      return "calc(".concat(this.getWidth(e), "% - ").concat(n, "px)");
    }, t.prototype.render = function () {
      var e,
        t,
        n,
        i,
        r = this,
        o = this.columns,
        a = this.gutterSize,
        s = (null === (i = null === (n = null === (t = this.props.builderState) || void 0 === t ? void 0 : t.context.builderContent) || void 0 === n ? void 0 : n.meta) || void 0 === i ? void 0 : i.breakpoints) || {},
        l = getSizesForBreakpoints(s);
      return jsx(React__default.Fragment, null, jsx("div", {
        className: "builder-columns",
        css: _assign({
          display: "flex"
        }, "never" !== this.props.stackColumnsAt && (e = {}, e["@media (max-width: ".concat("tablet" !== this.props.stackColumnsAt ? l.small.max : l.medium.max, "px)")] = {
          flexDirection: this.props.reverseColumnsWhenStacked ? "column-reverse" : "column",
          alignItems: "stretch"
        }, e))
      }, o.map(function (e, t) {
        var n,
          i,
          o = e.link ? Link : "div";
        return jsx(React__default.Fragment, {
          key: t
        }, jsx(o, _assign({
          className: "builder-column"
        }, e.link ? {
          href: e.link
        } : null, {
          css: _assign((n = {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            lineHeight: "normal"
          }, n["& > .builder-blocks"] = {
            flexGrow: 1
          }, n.width = r.getColumnWidth(t), n.marginLeft = 0 === t ? 0 : a, n), "never" !== r.props.stackColumnsAt && (i = {}, i["@media (max-width: ".concat("tablet" !== r.props.stackColumnsAt ? l.small.max : l.medium.max, "px)")] = {
            width: "100%",
            marginLeft: 0
          }, i))
        }), jsx(BuilderBlocks, {
          key: t,
          child: !0,
          parentElementId: r.props.builderBlock && r.props.builderBlock.id,
          blocks: e.blocks,
          dataPath: "component.options.columns.".concat(t, ".blocks")
        })));
      })));
    }, t;
  }(React__default.Component),
  Columns = withBuilder(ColumnsComponent, {
    name: "Columns",
    static: !0,
    inputs: [{
      name: "columns",
      type: "array",
      broadcast: !0,
      subFields: [{
        name: "blocks",
        type: "array",
        hideFromUI: !0,
        defaultValue: defaultBlocks
      }, {
        name: "width",
        type: "number",
        hideFromUI: !0,
        helperText: "Width %, e.g. set to 50 to fill half of the space"
      }, {
        name: "link",
        type: "url",
        helperText: "Optionally set a url that clicking this column will link to"
      }],
      defaultValue: [{
        blocks: defaultBlocks
      }, {
        blocks: defaultBlocks
      }],
      onChange: function onChange(e) {
        function t() {
          n.forEach(function (e) {
            e.delete("width");
          });
        }
        var n = e.get("columns");
        Array.isArray(n) && (!n.find(function (e) {
          return e.get("width");
        }) || (n.find(function (e) {
          return !e.get("width");
        }) || 100 !== n.reduce(function (e, t) {
          return e + t.get("width");
        }, 0)) && t());
      }
    }, {
      name: "space",
      type: "number",
      defaultValue: 20,
      helperText: "Size of gap between columns",
      advanced: !0
    }, {
      name: "stackColumnsAt",
      type: "string",
      defaultValue: "tablet",
      helperText: "Convert horizontal columns to vertical at what device size",
      enum: ["tablet", "mobile", "never"],
      advanced: !0
    }, {
      name: "reverseColumnsWhenStacked",
      type: "boolean",
      defaultValue: !1,
      helperText: "When stacking columns for mobile devices, reverse the ordering",
      advanced: !0
    }]
  }),
  EmbedComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.elementRef = null, t.scriptsInserted = new Set(), t.scriptsRun = new Set(), t;
    }
    return __extends(t, e), t.prototype.componentDidUpdate = function (e) {
      this.props.content !== e.content && this.findAndRunScripts();
    }, t.prototype.componentDidMount = function () {
      this.findAndRunScripts();
    }, t.prototype.findAndRunScripts = function () {
      if (this.elementRef && "undefined" != typeof window) for (var e = this.elementRef.getElementsByTagName("script"), t = 0; t < e.length; t++) {
        var n = e[t];
        if (n.src) {
          if (this.scriptsInserted.has(n.src)) continue;
          this.scriptsInserted.add(n.src);
          var i = document.createElement("script");
          i.async = !0, i.src = n.src, document.head.appendChild(i);
        } else {
          if (this.scriptsRun.has(n.innerText)) continue;
          this.scriptsRun.add(n.innerText);
          try {
            new Function(n.innerText)();
          } catch (e) {
            console.warn("Builder custom code component error:", e);
          }
        }
      }
    }, Object.defineProperty(t.prototype, "content", {
      get: function get() {
        return Builder.isServer ? (this.props.content || "").replace(/<script[\s\S]*?<\/script>/g, "") : this.props.content;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e = this;
      return React__default.createElement("div", {
        ref: function ref(t) {
          return e.elementRef = t;
        },
        className: "builder-embed",
        dangerouslySetInnerHTML: {
          __html: this.content
        }
      });
    }, t;
  }(React__default.Component),
  Embed = withBuilder(EmbedComponent, {
    name: "Embed",
    static: !0,
    inputs: [{
      name: "url",
      type: "url",
      required: !0,
      defaultValue: "",
      helperText: "e.g. enter a youtube url, google map, etc",
      onChange: function onChange(e) {
        var t = e.get("url");
        if (t) {
          e.set("content", "Loading...");
          return fetch("https://iframe.ly/api/iframely?url=".concat(t, "&api_key=").concat("ae0e60e78201a3f2b0de4b")).then(function (e) {
            return e.json();
          }).then(function (n) {
            e.get("url") === t && (n.html ? e.set("content", n.html) : e.set("content", "Invalid url, please try another"));
          }).catch(function (t) {
            e.set("content", "There was an error embedding this URL, please try again or another URL");
          });
        }
        e.delete("content");
      }
    }, {
      name: "content",
      type: "html",
      defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
      hideFromUI: !0
    }]
  }),
  globalReplaceNodes = {} || null,
  isShopify$1 = Builder.isBrowser && "Shopify" in window;
if (Builder.isBrowser && globalReplaceNodes) {
  var customCodeQuerySelector_1 = ".builder-custom-code";
  try {
    var allCustomCodeElements_1 = Array.from(document.querySelectorAll(customCodeQuerySelector_1)),
      builderTemplates = document.querySelectorAll("template[data-template-variant-id]");
    builderTemplates.length && Array.from(builderTemplates).forEach(function (e) {
      var t = e.content.querySelectorAll(customCodeQuerySelector_1);
      t.length && (allCustomCodeElements_1 = allCustomCodeElements_1.concat(Array.from(t)));
    }), allCustomCodeElements_1.forEach(function (e) {
      var t = e.parentElement,
        n = t && t.getAttribute("builder-id");
      n && (globalReplaceNodes[n] = globalReplaceNodes[n] || [], globalReplaceNodes[n].push(isShopify$1 ? e : e.cloneNode(!0)));
    });
  } catch (e) {
    console.error("Builder replace nodes error:", e);
  }
}
var CustomCodeComponent = function (e) {
    function t(t) {
      var n,
        i = this;
      if ((i = e.call(this, t) || this).elementRef = null, i.originalRef = null, i.scriptsInserted = new Set(), i.scriptsRun = new Set(), i.firstLoad = !0, i.replaceNodes = !1, i.state = {
        hydrated: !1
      }, Builder.isBrowser) {
        var r = null === (n = i.props.builderBlock) || void 0 === n ? void 0 : n.id;
        if (i.replaceNodes = Boolean(Builder.isBrowser && (t.replaceNodes || isShopify$1) && r && (null == globalReplaceNodes ? void 0 : globalReplaceNodes[r])), i.firstLoad && i.props.builderBlock) if (r && (null == globalReplaceNodes ? void 0 : globalReplaceNodes[r])) {
          var o = globalReplaceNodes[r].shift() || null;
          i.originalRef = o, 0 === globalReplaceNodes[r].length && delete globalReplaceNodes[r];
        } else if (i.replaceNodes) {
          var a = document.querySelectorAll(".".concat(i.props.builderBlock.id, " .builder-custom-code"));
          if (1 === a.length) {
            var s = a[0];
            i.originalRef = s, i.originalRef.remove();
          }
        }
      }
      return i;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "noReactRender", {
      get: function get() {
        var e;
        return Boolean(isShopify$1 && (null === (e = this.props.code) || void 0 === e ? void 0 : e.match(/{[{%]/g)));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isHydrating", {
      get: function get() {
        return !isShopify$1 && this.originalRef;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidUpdate = function (e) {
      this.props.code !== e.code && this.findAndRunScripts();
    }, t.prototype.componentDidMount = function () {
      var e = this;
      this.firstLoad = !1, this.replaceNodes || (this.isHydrating ? (this.setState({
        hydrated: !0
      }), Builder.nextTick(function () {
        return e.findAndRunScripts();
      })) : this.findAndRunScripts()), Builder.isBrowser && this.replaceNodes && this.originalRef && this.elementRef && this.elementRef.appendChild(this.originalRef);
    }, t.prototype.findAndRunScripts = function () {
      if (this.elementRef && "undefined" != typeof window) for (var e = this.elementRef.getElementsByTagName("script"), t = 0; t < e.length; t++) {
        var n = e[t];
        if (n.src) {
          if (this.scriptsInserted.has(n.src)) continue;
          this.scriptsInserted.add(n.src);
          var i = document.createElement("script");
          i.async = !0, i.src = n.src, document.head.appendChild(i);
        } else if (!n.type || ["text/javascript", "application/javascript", "application/ecmascript"].includes(n.type)) {
          if (this.scriptsRun.has(n.innerText)) continue;
          try {
            this.scriptsRun.add(n.innerText), new Function(n.innerText)();
          } catch (e) {
            console.warn("Builder custom code component error:", e);
          }
        }
      }
    }, Object.defineProperty(t.prototype, "code", {
      get: function get() {
        return (Builder.isServer || this.isHydrating && this.firstLoad) && this.props.scriptsClientOnly ? (this.props.code || "").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "") : this.props.code;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e = this;
      return React__default.createElement("div", _assign({
        ref: function ref(t) {
          return e.elementRef = t;
        },
        className: "builder-custom-code"
      }, !this.replaceNodes && !this.noReactRender && {
        dangerouslySetInnerHTML: {
          __html: this.code
        }
      }));
    }, t;
  }(React__default.Component),
  CustomCode = withBuilder(CustomCodeComponent, {
    name: "Custom Code",
    static: !0,
    requiredPermissions: ["editCode"],
    inputs: [{
      name: "code",
      type: "html",
      required: !0,
      defaultValue: "<p>Hello there, I am custom HTML code!</p>",
      code: !0
    }, _assign({
      name: "replaceNodes",
      type: "boolean",
      helperText: "Preserve server rendered dom nodes",
      advanced: !0
    }, isShopify$1 && {
      defaultValue: !0
    }), _assign({
      name: "scriptsClientOnly",
      type: "boolean",
      helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
      advanced: !0
    }, !isShopify$1 && {
      defaultValue: !0
    })]
  });
function removeProtocol(e) {
  return e.replace(/http(s)?:/, "");
}
function isElementInViewport(e) {
  var t = e.getBoundingClientRect();
  return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function getShopifyImageUrl(e, t) {
  if (!e || !(null == e ? void 0 : e.match(/cdn\.shopify\.com/)) || !t) return e;
  if ("master" === t) return removeProtocol(e);
  var n = e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (n) {
    var i = e.split(n[0]),
      r = n[3],
      o = t.match("x") ? t : "".concat(t, "x");
    return removeProtocol("".concat(i[0], "_").concat(o).concat(r));
  }
  return null;
}
var DEFAULT_ASPECT_RATIO$1 = .7041;
function updateQueryParam(e, t, n) {
  void 0 === e && (e = "");
  var i = new RegExp("([?&])" + t + "=.*?(&|$)", "i"),
    r = -1 !== e.indexOf("?") ? "&" : "?";
  return e.match(i) ? e.replace(i, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + r + t + "=" + encodeURIComponent(n);
}
function getSrcSet(e) {
  if (!e) return e;
  var t = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (e.match(/builder\.io/)) {
    var n = e,
      i = Number(e.split("?width=")[1]);
    return isNaN(i) || (n = "".concat(n, " ").concat(i, "w")), t.filter(function (e) {
      return e !== i;
    }).map(function (t) {
      return "".concat(updateQueryParam(e, "width", t), " ").concat(t, "w");
    }).concat([n]).join(", ");
  }
  return e.match(/cdn\.shopify\.com/) ? t.map(function (t) {
    return [getShopifyImageUrl(e, "".concat(t, "x").concat(t)), t];
  }).filter(function (e) {
    return !!e[0];
  }).map(function (e) {
    var t = e[0],
      n = e[1];
    return "".concat(t, " ").concat(n, "w");
  }).concat([e]).join(", ") : e;
}
var getSizes = function getSizes(e, t, n) {
    var i, r, o, a, s, l, u, d;
    void 0 === n && (n = {});
    var c = "";
    if (e) {
      var p = e.split(","),
        f = p.length;
      c = p.map(function (e, t) {
        return f === t + 1 ? e.replace(/\([\s\S]*?\)/g, "").trim() : e;
      }).join(", ");
    } else if (t && t.responsiveStyles) {
      var m = [],
        h = !1,
        g = /^\d+/,
        v = getSizesForBreakpoints(n);
      if (null === (o = null === (r = null === (i = t.responsiveStyles) || void 0 === i ? void 0 : i.small) || void 0 === r ? void 0 : r.width) || void 0 === o ? void 0 : o.match(g)) {
        h = !0;
        var b = "(max-width: ".concat(v.small.max, "px)"),
          y = "".concat(b, " ").concat(t.responsiveStyles.small.width.replace("%", "vw"));
        m.push(y);
      }
      if (null === (l = null === (s = null === (a = t.responsiveStyles) || void 0 === a ? void 0 : a.medium) || void 0 === s ? void 0 : s.width) || void 0 === l ? void 0 : l.match(g)) {
        h = !0;
        b = "(max-width: ".concat(v.medium.max, "px)"), y = "".concat(b, " ").concat(t.responsiveStyles.medium.width.replace("%", "vw"));
        m.push(y);
      }
      if (null === (d = null === (u = t.responsiveStyles) || void 0 === u ? void 0 : u.large) || void 0 === d ? void 0 : d.width) {
        var _ = t.responsiveStyles.large.width.replace("%", "vw");
        m.push(_);
      } else h && m.push("100vw");
      m.length && (c = m.join(", "));
    }
    return c;
  },
  ImageComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.state = {
        imageLoaded: !t.useLazyLoading,
        load: !t.useLazyLoading
      }, t.pictureRef = null, t.scrollListener = null, t.intersectionObserver = null, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "useLazyLoading", {
      get: function get() {
        return (!Builder.isBrowser || !location.search.includes("builder.lazyLoadImages=false")) && (!(!Builder.isBrowser || !location.href.includes("builder.lazyLoadImages=true")) || this.props.lazy);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentWillUnmount = function () {
      Builder.isBrowser && (this.scrollListener && (window.removeEventListener("scroll", this.scrollListener), this.scrollListener = null), this.intersectionObserver && this.pictureRef && this.intersectionObserver.unobserve(this.pictureRef));
    }, t.prototype.componentDidMount = function () {
      var e = this;
      if (this.props.lazy && Builder.isBrowser) if (this.pictureRef && isElementInViewport(this.pictureRef)) this.setState({
        load: !0
      });else if ("function" == typeof IntersectionObserver && this.pictureRef) {
        (this.intersectionObserver = new IntersectionObserver(function (t, n) {
          t.forEach(function (t) {
            t.intersectionRatio > 0 && (e.setState({
              load: !0
            }), e.pictureRef && n.unobserve(e.pictureRef));
          });
        })).observe(this.pictureRef);
      } else {
        var t = throttle(function (n) {
          if (e.pictureRef) {
            var i = e.pictureRef.getBoundingClientRect(),
              r = window.innerHeight / 2;
            i.top < window.innerHeight + r && (e.setState(_assign(_assign({}, e.state), {
              load: !0
            })), window.removeEventListener("scroll", t), e.scrollListener = null);
          }
        }, 400, {
          leading: !1,
          trailing: !0
        });
        this.scrollListener = t, window.addEventListener("scroll", t, {
          capture: !0,
          passive: !0
        }), t();
      }
    }, Object.defineProperty(t.prototype, "image", {
      get: function get() {
        return this.props.image || this.props.src;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getSrcSet = function () {
      var e = this.image;
      if (e && (e.match(/builder\.io/) || e.match(/cdn\.shopify\.com/))) return getSrcSet(e);
    }, t.prototype.render = function () {
      var e,
        t,
        n = this,
        i = this.props,
        r = i.aspectRatio,
        o = i.lazy,
        a = i.builderBlock,
        s = i.builderState,
        l = this.props.builderBlock && this.props.builderBlock.children,
        u = this.props.srcset,
        d = getSizes(this.props.sizes, a, (null === (t = null === (e = null == s ? void 0 : s.context.builderContent) || void 0 === e ? void 0 : e.meta) || void 0 === t ? void 0 : t.breakpoints) || {}),
        c = this.image;
      u && c && c.includes("builder.io/api/v1/image") ? u.includes(c.split("?")[0]) || (console.debug("Removed given srcset"), u = this.getSrcSet()) : c && !u && (u = this.getSrcSet());
      var p = null == a ? void 0 : a.id.startsWith("builder-pixel-"),
        f = this.props.fitContent;
      return jsx(BuilderMetaContext.Consumer, null, function (e) {
        var t,
          i = e.ampMode,
          a = i ? "amp-img" : "img",
          s = (!o || n.state.load || i) && jsx(a, _assign({}, i ? {
            layout: "responsive",
            height: n.props.height || (r ? Math.round(1e3 * r) : void 0),
            width: n.props.width || (r ? Math.round(1e3 / r) : void 0)
          } : null, {
            alt: n.props.altText,
            key: Builder.isEditing && "string" == typeof n.image && n.image.split("?")[0] || void 0,
            role: n.props.altText ? void 0 : "presentation",
            css: _assign(_assign({
              opacity: i ? 1 : n.useLazyLoading && !n.state.imageLoaded ? 0 : 1,
              transition: "opacity 0.2s ease-in-out",
              objectFit: n.props.backgroundSize || "cover",
              objectPosition: n.props.backgroundPosition || "center"
            }, r && !i && {
              position: "absolute",
              height: "100%",
              width: "100%",
              left: 0,
              top: 0
            }), i && (t = {}, t["& img"] = {
              objectFit: n.props.backgroundSize,
              objectPosition: n.props.backgroundPosition
            }, t)),
            loading: p ? "eager" : "lazy",
            className: "builder-image" + (n.props.className ? " " + n.props.className : ""),
            src: n.image
          }, !i && {
            onLoad: function onLoad() {
              return n.setState({
                imageLoaded: !0
              });
            }
          }, {
            srcSet: u,
            sizes: !i && d ? d : void 0
          }));
        return jsx(React__default.Fragment, null, i ? s : jsx("picture", {
          ref: function ref(e) {
            return n.pictureRef = e;
          }
        }, u && u.match(/builder\.io/) && !n.props.noWebp && jsx("source", {
          srcSet: u.replace(/\?/g, "?format=webp&"),
          type: "image/webp"
        }), s), !r || i || f && l && l.length ? null : jsx("div", {
          className: "builder-image-sizer",
          css: {
            width: "100%",
            paddingTop: 100 * r + "%",
            pointerEvents: "none",
            fontSize: 0
          }
        }, " "), l && l.length ? f ? l.map(function (e, t) {
          return jsx(BuilderBlock$1, {
            key: e.id,
            block: e
          });
        }) : jsx("div", {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }
        }, l.map(function (e, t) {
          return jsx(BuilderBlock$1, {
            key: e.id,
            block: e
          });
        })) : null);
      });
    }, t;
  }(React__default.Component),
  Image = withBuilder(ImageComponent, {
    name: "Image",
    static: !0,
    image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
    defaultStyles: {
      position: "relative",
      minHeight: "20px",
      minWidth: "20px",
      overflow: "hidden"
    },
    canHaveChildren: !0,
    inputs: [{
      name: "image",
      type: "file",
      bubble: !0,
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      required: !0,
      defaultValue: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",
      onChange: function onChange(e) {
        e.delete("srcset"), e.delete("noWebp");
        var t,
          n,
          i = e.get("image"),
          r = e.get("aspectRatio");
        if (fetch(i).then(function (e) {
          return e.blob();
        }).then(function (t) {
          t.type.includes("svg") && e.set("noWebp", !0);
        }), i && (!r || .7041 === r)) return (t = i, void 0 === n && (n = 6e4), new Promise(function (e, i) {
          var r = document.createElement("img"),
            o = !1;
          r.onload = function () {
            o = !0, e(r);
          }, r.addEventListener("error", function (e) {
            console.warn("Image load failed", e.error), i(e.error);
          }), r.src = t, setTimeout(function () {
            o || i(new Error("Image load timed out"));
          }, n);
        })).then(function (t) {
          var n,
            r = e.get("aspectRatio");
          e.get("image") !== i || r && .7041 !== r || t.width && t.height && (e.set("aspectRatio", (n = t.height / t.width, Math.round(1e3 * n) / 1e3)), e.set("height", t.height), e.set("width", t.width));
        });
      }
    }, {
      name: "backgroundSize",
      type: "text",
      defaultValue: "cover",
      enum: [{
        label: "contain",
        value: "contain",
        helperText: "The image should never get cropped"
      }, {
        label: "cover",
        value: "cover",
        helperText: "The image should fill its box, cropping when needed"
      }]
    }, {
      name: "backgroundPosition",
      type: "text",
      defaultValue: "center",
      enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
    }, {
      name: "altText",
      type: "string",
      helperText: "Text to display when the user has images off"
    }, {
      name: "height",
      type: "number",
      hideFromUI: !0
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0
    }, {
      name: "sizes",
      type: "string",
      hideFromUI: !0
    }, {
      name: "srcset",
      type: "string",
      hideFromUI: !0
    }, {
      name: "lazy",
      type: "boolean",
      defaultValue: !0,
      hideFromUI: !0
    }, {
      name: "fitContent",
      type: "boolean",
      helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
      defaultValue: !0
    }, {
      name: "aspectRatio",
      type: "number",
      helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
      advanced: !0,
      defaultValue: DEFAULT_ASPECT_RATIO$1
    }]
  }),
  DEFAULT_ASPECT_RATIO = .7004048582995948,
  VideoComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.video = null, t.containerRef = null, t.scrollListener = null, t.state = {
        load: !t.lazyLoad
      }, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "lazyLoad", {
      get: function get() {
        return !1 !== this.props.lazyLoad;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateVideo = function () {
      var e = this,
        t = this.video;
      if (t) {
        ["muted", "playsInline", "autoPlay"].forEach(function (n) {
          var i = n.toLowerCase();
          e.props[n] ? t.setAttribute(i, i) : t.removeAttribute(i);
        });
      }
    }, t.prototype.componentDidUpdate = function () {
      this.updateVideo();
    }, t.prototype.componentDidMount = function () {
      var e = this;
      if (this.updateVideo(), this.lazyLoad && Builder.isBrowser) {
        var t = throttle(function (n) {
          if (e.containerRef) {
            var i = e.containerRef.getBoundingClientRect(),
              r = window.innerHeight / 2;
            i.top < window.innerHeight + r && (e.setState(function (e) {
              return _assign(_assign({}, e), {
                load: !0
              });
            }), window.removeEventListener("scroll", t), e.scrollListener = null);
          }
        }, 400, {
          leading: !1,
          trailing: !0
        });
        this.scrollListener = t, window.addEventListener("scroll", t, {
          capture: !0,
          passive: !0
        }), t();
      }
    }, t.prototype.componentWillUnmount = function () {
      Builder.isBrowser && this.scrollListener && (window.removeEventListener("scroll", this.scrollListener), this.scrollListener = null);
    }, t.prototype.render = function () {
      var e = this,
        t = this.props,
        n = t.aspectRatio,
        i = t.children;
      return jsx("div", {
        ref: function ref(t) {
          return e.containerRef = t;
        },
        css: {
          position: "relative"
        }
      }, jsx("video", {
        key: this.props.video || "no-src",
        poster: this.props.posterImage,
        ref: function ref(t) {
          return e.video = t;
        },
        autoPlay: this.props.autoPlay,
        muted: this.props.muted,
        controls: this.props.controls,
        loop: this.props.loop,
        className: "builder-video",
        css: _assign({
          width: "100%",
          height: "100%",
          objectFit: this.props.fit,
          objectPosition: this.props.position,
          zIndex: 2,
          borderRadius: 1
        }, n ? {
          position: "absolute"
        } : null)
      }, (!this.lazyLoad || this.state.load) && jsx("source", {
        type: "video/mp4",
        src: this.props.video
      })), !n || this.props.fitContent && i ? null : jsx("div", {
        css: {
          width: "100%",
          paddingTop: 100 * n + "%",
          pointerEvents: "none",
          fontSize: 0
        }
      }), i && this.props.fitContent ? jsx("div", {
        css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        }
      }, i) : i ? jsx("div", {
        css: {
          pointerEvents: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        }
      }, i) : null);
    }, t;
  }(React__default.Component),
  Video = Builder.registerComponent(withChildren(VideoComponent), {
    name: "Video",
    canHaveChildren: !0,
    defaultStyles: {
      minHeight: "20px",
      minWidth: "20px"
    },
    image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
    inputs: [{
      name: "video",
      type: "file",
      allowedFileTypes: ["mp4"],
      bubble: !0,
      defaultValue: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",
      required: !0
    }, {
      name: "posterImage",
      type: "file",
      allowedFileTypes: ["jpeg", "png"],
      helperText: "Image to show before the video plays"
    }, {
      name: "autoPlay",
      type: "boolean",
      defaultValue: !0
    }, {
      name: "controls",
      type: "boolean",
      defaultValue: !1
    }, {
      name: "muted",
      type: "boolean",
      defaultValue: !0
    }, {
      name: "loop",
      type: "boolean",
      defaultValue: !0
    }, {
      name: "playsInline",
      type: "boolean",
      defaultValue: !0
    }, {
      name: "fit",
      type: "text",
      defaultValue: "cover",
      enum: ["contain", "cover", "fill", "auto"]
    }, {
      name: "fitContent",
      type: "boolean",
      helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
      defaultValue: !0,
      advanced: !0
    }, {
      name: "position",
      type: "text",
      defaultValue: "center",
      enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
    }, {
      name: "height",
      type: "number",
      advanced: !0
    }, {
      name: "width",
      type: "number",
      advanced: !0
    }, {
      name: "aspectRatio",
      type: "number",
      advanced: !0,
      defaultValue: DEFAULT_ASPECT_RATIO
    }, {
      name: "lazyLoad",
      type: "boolean",
      helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
      defaultValue: !0,
      advanced: !0
    }]
  }),
  size = function size(e) {
    return Object.keys(e).length;
  },
  isShopify = Builder.isBrowser && "Shopify" in window,
  refs = {};
if (Builder.isBrowser) try {
  Array.from(document.querySelectorAll("[builder-static-symbol]")).forEach(function (e) {
    var t = e.getAttribute("builder-static-symbol");
    t && (refs[t] = e);
  });
} catch (e) {
  console.error("Builder replace nodes error:", e);
}
var SymbolComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.ref = null, t.staticRef = null, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "placeholder", {
      get: function get() {
        return jsx("div", {
          css: {
            padding: 10
          }
        }, "Symbols let you reuse dynamic elements across your content. Please choose a model and entry for this symbol.");
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function () {
      var e, t, n;
      this.useStatic && this.staticRef && refs[null === (e = this.props.builderBlock) || void 0 === e ? void 0 : e.id] && (null === (t = this.staticRef.parentNode) || void 0 === t || t.replaceChild(refs[null === (n = this.props.builderBlock) || void 0 === n ? void 0 : n.id], this.staticRef));
    }, Object.defineProperty(t.prototype, "useStatic", {
      get: function get() {
        var e;
        return Boolean(Builder.isBrowser && refs[null === (e = this.props.builderBlock) || void 0 === e ? void 0 : e.id] && !(Builder.isEditing || Builder.isPreviewing));
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e,
        t = this;
      if (this.useStatic) return jsx("div", {
        ref: function ref(e) {
          return t.staticRef = e;
        }
      });
      var n = this.props.symbol,
        i = !1;
      n || (i = !0);
      var r = this.props.dataOnly ? NoWrap : this.props.builderBlock && this.props.builderBlock.tagName || "div",
        o = n || {},
        a = o.model,
        s = o.entry,
        l = o.data,
        u = o.content,
        d = o.inline,
        c = (null == n ? void 0 : n.dynamic) || this.props.dynamic;
      a && (s || c) || (null === (e = null == u ? void 0 : u.data) || void 0 === e ? void 0 : e.blocksJs) || d || (i = !0);
      var p = c ? void 0 : [a, s].join(":"),
        f = Builder.isEditing ? null : l && size(l) && hash(l);
      p && f && f.length < 300 && (p += ":" + f);
      var m = this.props.attributes || {};
      return jsx(BuilderStoreContext.Consumer, {
        key: (a || "no model") + ":" + (s || "no entry")
      }, function (e) {
        var o,
          d,
          c,
          f,
          h,
          g,
          v,
          b,
          y,
          _,
          x,
          S = "".concat(p, "_").concat((null === (o = null == e ? void 0 : e.state) || void 0 === o ? void 0 : o.locale) || "Default");
        return jsx(r, _assign({
          "data-model": a
        }, m, {
          className: (m.class || m.className || "") + " builder-symbol" + ((null == n ? void 0 : n.inline) ? " builder-inline-symbol" : "") + ((null == n ? void 0 : n.dynamic) || t.props.dynamic ? " builder-dynamic-symbol" : "")
        }), i ? t.placeholder : jsx(BuilderComponent, _assign({}, (null === (d = e.state) || void 0 === d ? void 0 : d.locale) && {
          locale: e.state.locale
        }, {
          isChild: !0,
          ref: function ref(e) {
            return t.ref = e;
          },
          context: _assign(_assign({}, e.context), {
            symbolId: null === (c = t.props.builderBlock) || void 0 === c ? void 0 : c.id
          }),
          modelName: a,
          entry: s,
          data: _assign(_assign(_assign({}, l), !!t.props.inheritState && e.state), null === (y = null === (b = null === (v = null === (g = null === (h = null === (f = t.props.builderBlock) || void 0 === f ? void 0 : f.component) || void 0 === h ? void 0 : h.options) || void 0 === g ? void 0 : g.symbol) || void 0 === v ? void 0 : v.content) || void 0 === b ? void 0 : b.data) || void 0 === y ? void 0 : y.state),
          renderLink: e.renderLink,
          inlineContent: null == n ? void 0 : n.inline
        }, u && {
          content: u
        }, {
          key: S,
          options: {
            key: S,
            noEditorUpdates: !0
          },
          codegen: !!(null === (_ = null == u ? void 0 : u.data) || void 0 === _ ? void 0 : _.blocksJs),
          hydrate: null === (x = e.state) || void 0 === x ? void 0 : x._hydrate,
          builderBlock: t.props.builderBlock,
          dataOnly: t.props.dataOnly
        }), t.props.children));
      });
    }, t;
  }(React__default.Component),
  Symbol$1 = withBuilder(SymbolComponent, {
    name: "Symbol",
    noWrap: !0,
    static: !0,
    inputs: [{
      name: "symbol",
      type: "uiSymbol"
    }, {
      name: "dataOnly",
      helperText: "Make this a data symbol that doesn't display any UI",
      type: "boolean",
      defaultValue: !1,
      advanced: !0,
      hideFromUI: !0
    }, {
      name: "inheritState",
      helperText: "Inherit the parent component state and data",
      type: "boolean",
      defaultValue: isShopify,
      advanced: !0
    }, {
      name: "renderToLiquid",
      helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
      type: "boolean",
      defaultValue: isShopify,
      advanced: !0,
      hideFromUI: !0
    }, {
      name: "useChildren",
      hideFromUI: !0,
      type: "boolean"
    }]
  }),
  ButtonComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      var e = this.props.link ? Link : "span";
      return React__default.createElement(e, _assign({
        role: "button",
        href: this.props.link,
        target: this.props.openLinkInNewTab ? "_blank" : void 0
      }, this.props.attributes), this.props.text);
    }, t;
  }(React__default.Component),
  Button = withBuilder(ButtonComponent, {
    name: "Core:Button",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
    defaultStyles: {
      appearance: "none",
      paddingTop: "15px",
      paddingBottom: "15px",
      paddingLeft: "25px",
      paddingRight: "25px",
      backgroundColor: "#000000",
      color: "white",
      borderRadius: "4px",
      textAlign: "center",
      cursor: "pointer"
    },
    inputs: [{
      name: "text",
      type: "text",
      defaultValue: "Click me!",
      bubble: !0
    }, {
      name: "link",
      type: "url",
      bubble: !0
    }, {
      name: "openLinkInNewTab",
      type: "boolean",
      defaultValue: !1,
      friendlyName: "Open link in new tab"
    }],
    static: !0,
    noWrap: !0
  }),
  SectionComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.ref = null, t.unmountCallbacks = [], t.state = {
        inView: !1
      }, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "renderContents", {
      get: function get() {
        return !0 !== this.props.lazyLoad || this.state.inView;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentWillUnmount = function () {
      this.unmountCallbacks.forEach(function (e) {
        return e();
      });
    }, t.prototype.componentDidMount = function () {
      var e = this;
      if (this.props.lazyLoad) if ("undefined" != typeof IntersectionObserver && this.ref) {
        var t = new IntersectionObserver(function (t, n) {
          t.forEach(function (t) {
            t.intersectionRatio > 0 && (e.setState({
              inView: !0
            }), e.ref && n.unobserve(e.ref));
          });
        }, {
          rootMargin: "10px"
        });
        t.observe(this.ref), this.unmountCallbacks.push(function () {
          e.ref && t.unobserve(e.ref);
        });
      } else this.setState({
        inView: !0
      });
    }, t.prototype.render = function () {
      var e = this;
      return jsx("section", {
        ref: function ref(t) {
          return e.ref = t;
        },
        css: _assign({
          width: "100%",
          alignSelf: "stretch",
          flexGrow: 1,
          boxSizing: "border-box",
          maxWidth: this.props.maxWidth,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          marginLeft: "auto",
          marginRight: "auto"
        }, this.renderContents ? null : this.props.lazyStyles)
      }, this.renderContents ? jsx(React__default.Fragment, null, this.props.children, this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e, t) {
        return jsx(BuilderBlock$1, {
          key: e.id,
          block: e
        });
      })) : null);
    }, t;
  }(React__default.Component),
  Section = withBuilder(SectionComponent, {
    name: "Core:Section",
    static: !0,
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
    inputs: [{
      name: "maxWidth",
      type: "number",
      defaultValue: 1200
    }, {
      name: "lazyLoad",
      type: "boolean",
      defaultValue: !1,
      advanced: !0,
      description: "Only render this section when in view"
    }],
    defaultStyles: {
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "50px",
      paddingBottom: "50px",
      marginTop: "0px",
      width: "100vw",
      marginLeft: "calc(50% - 50vw)"
    },
    canHaveChildren: !0,
    defaultChildren: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          textAlign: "center"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
        }
      }
    }]
  }),
  StateProviderComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      var e = this;
      return React__default.createElement(BuilderStoreContext.Consumer, null, function (t) {
        return React__default.createElement(BuilderStoreContext.Provider, {
          value: _assign(_assign({}, t), {
            state: _assign(_assign({}, t.state), e.props.state),
            context: _assign(_assign({}, t.context), e.props.context)
          })
        }, e.props.builderBlock && e.props.builderBlock.children && e.props.builderBlock.children.map(function (e, t) {
          return React__default.createElement(BuilderBlock$1, {
            block: e,
            key: e.id,
            index: t,
            child: !0
          });
        }), e.props.children);
      });
    }, t;
  }(React__default.Component),
  StateProvider = withBuilder(StateProviderComponent, {
    name: "Builder:StateProvider",
    canHaveChildren: !0,
    static: !0,
    noWrap: !0,
    hideFromInsertMenu: !0
  }),
  prefetched = new Set();
function searchToObject(e) {
  var t = (e.search || "").substring(1).split("&"),
    n = {};
  for (var i in t) if (t[i] && "string" == typeof t[i]) {
    var r = t[i].split("=");
    n[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
  }
  return n;
}
var RouterComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.builder = builder, t.routed = !1, t.preloadQueue = 0, t.onPopState = function (e) {
        t.updateLocationState();
      }, t.onMouseOverOrTouchStart = function (e) {
        if (!(t.preloadQueue > 4) && !1 !== t.props.preloadOnHover) {
          var n = t.findHrefTarget(e);
          if (n) {
            var i = n.getAttribute("href");
            if (i) {
              if (!t.isRelative(i)) {
                var r = t.convertToRelative(i);
                if (!r) return;
                i = r;
              }
              if (!i.startsWith("#") && !prefetched.has(i)) {
                prefetched.add(i);
                var o = t.parseUrl(i);
                t.preloadQueue++;
                var a = builder.getUserAttributes();
                a.urlPath = o.pathname, a.queryString = o.search;
                var s = builder.get(t.model, {
                  userAttributes: a,
                  key: t.model + ":" + o.pathname + o.search
                }).subscribe(function () {
                  t.preloadQueue--, s.unsubscribe();
                });
              }
            }
          }
        }
      }, t.onClick = function (e) {
        return __awaiter(t, void 0, void 0, function () {
          var t, n, i, r;
          return __generator(this, function (o) {
            if (!1 === this.props.handleRouting) return [2];
            if (0 !== e.button || e.ctrlKey || e.defaultPrevented || e.metaKey) return [2];
            if (!(t = this.findHrefTarget(e))) return [2];
            if (t.target && "_client" !== t.target) return [2];
            if (!(n = t.getAttribute("href"))) return [2];
            if (this.props.onRoute && (i = {
              url: n,
              anchorNode: t,
              preventDefault: function preventDefault() {
                this.defaultPrevented = !0;
              },
              defaultPrevented: !1
            }, this.props.onRoute(i), i.defaultPrevented)) return [2];
            if (!this.isRelative(n)) {
              if (!(r = this.convertToRelative(n))) return [2];
              n = r;
            }
            return n.startsWith("#") || (e.preventDefault(), this.route(n)), [2];
          });
        });
      }, t.privateState = null, t;
    }
    return __extends(t, e), t.prototype.route = function (e) {
      var t;
      return this.routed = !0, "function" == typeof (null === (t = window.history) || void 0 === t ? void 0 : t.pushState) ? (history.pushState(null, "", e), this.updateLocationState(), !0) : (location.href = e, !1);
    }, t.prototype.updateLocationState = function () {
      this.privateState && this.privateState.update(function (e) {
        e.location = _assign(_assign({}, e.location), {
          pathname: location.pathname,
          search: location.search,
          path: location.pathname.split("/").slice(1),
          query: searchToObject(location)
        });
      });
    }, Object.defineProperty(t.prototype, "model", {
      get: function get() {
        return this.props.model || "page";
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function () {
      "undefined" != typeof document && (document.addEventListener("click", this.onClick), window.addEventListener("popstate", this.onPopState), document.addEventListener("mouseover", this.onMouseOverOrTouchStart), document.addEventListener("touchstart", this.onMouseOverOrTouchStart));
    }, t.prototype.componentWillUnmount = function () {
      "undefined" != typeof document && (document.removeEventListener("click", this.onClick), document.removeEventListener("mouseover", this.onMouseOverOrTouchStart), window.removeEventListener("popstate", this.onPopState), document.removeEventListener("touchstart", this.onMouseOverOrTouchStart));
    }, t.prototype.render = function () {
      var e = this,
        t = this.model;
      return jsx(BuilderStoreContext.Consumer, null, function (n) {
        e.privateState = n;
        var i = n.state && n.state.location && n.state.location.pathname + n.state.location.search;
        return jsx("div", {
          className: "builder-router",
          "data-model": t
        }, jsx("style", null, "\n                @keyframes builderLoadingSpinner {\n                  0% {\n                    transform: rotate(0deg);\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                  }\n                }\n                /* TODO: overridable tag */\n                .builder-page-loading {\n                  -webkit-animation: builderLoadingSpinner 1s infinite linear;\n                  animation: builderLoadingSpinner 1s infinite linear;\n                  -webkit-transform: translateZ(0);\n                  transform: translateZ(0);\n                  border-radius: 50%;\n                  width: 36px;\n                  height: 36px;\n                  margin: 6px auto;\n                  position: relative;\n                  border: 1px solid transparent;\n                  border-left: 1px solid #808284;\n                }\n              "), jsx(BuilderComponent, {
          key: i,
          data: e.props.data,
          content: e.routed ? void 0 : e.props.content,
          modelName: t,
          options: {
            key: Builder.isEditing ? void 0 : e.model + ":" + i
          }
        }, e.props.children || jsx("div", {
          css: {
            display: "flex"
          }
        }, jsx("div", {
          css: {
            margin: "40vh auto"
          },
          className: "builder-page-loading"
        }))));
      });
    }, t.prototype.findHrefTarget = function (e) {
      for (var t = e.target; t;) {
        if (t instanceof HTMLAnchorElement && t.getAttribute("href")) return t;
        if (t === e.currentTarget) break;
        t = t.parentElement;
      }
      return null;
    }, t.prototype.isRelative = function (e) {
      return !e.match(/^(\/\/|https?:\/\/)/i);
    }, t.prototype.parseUrl = function (e) {
      var t = document.createElement("a");
      return t.href = e, t;
    }, t.prototype.convertToRelative = function (e) {
      var t = this.parseUrl(location.href),
        n = this.parseUrl(e);
      if (t.host === n.host) {
        var i = n.pathname + (n.search ? n.search : "");
        return i.startsWith("#") ? null : i || "/";
      }
      return null;
    }, t;
  }(React__default.Component),
  Router = withBuilder(RouterComponent, {
    name: "Core:Router",
    hideFromInsertMenu: !0,
    inputs: [{
      name: "model",
      type: "string",
      defaultValue: "page",
      advanced: !0
    }, {
      name: "handleRouting",
      type: "boolean",
      defaultValue: !0,
      advanced: !0
    }, {
      name: "preloadOnHover",
      type: "boolean",
      defaultValue: !0,
      advanced: !0
    }, {
      name: "onRoute",
      type: "function",
      advanced: !0
    }]
  });
function Mutation(e) {
  var t,
    n,
    i = React__default.useRef(null);
  useWaitForSelector(e.selector, function (t) {
    "afterEnd" !== e.type && (t.innerHTML = ""), t.appendChild(i.current.firstElementChild);
  });
  var r = null === (t = e.builderBlock) || void 0 === t ? void 0 : t.children;
  return jsx("span", {
    style: {
      display: "none"
    },
    ref: i
  }, jsx(BuilderBlocks, {
    style: {
      display: "inline"
    },
    child: !0,
    parentElementId: null === (n = e.builderBlock) || void 0 === n ? void 0 : n.id,
    dataPath: "this.children",
    blocks: r
  }));
}
function useWaitForSelector(e, t) {
  React__default.useLayoutEffect(function () {
    try {
      var n = document.querySelector(e);
      if (n) return void t(n);
    } catch (e) {
      console.warn(e);
    }
    var i = new MutationObserver(function () {
      try {
        var n = document.querySelector(e);
        n && (i.disconnect(), t(n));
      } catch (e) {
        console.warn(e);
      }
    });
    return i.observe(document.body, {
      attributes: !0,
      subtree: !0,
      characterData: !0
    }), function () {
      i.disconnect();
    };
  }, [e]);
}
Builder.registerComponent(Mutation, {
  name: "Builder:Mutation",
  canHaveChildren: !0,
  noWrap: !0,
  hideFromInsertMenu: !0,
  inputs: [{
    name: "type",
    type: "string",
    defaultValue: "replace",
    enum: [{
      label: "Replace",
      value: "replace",
      helperText: "Replace the contents of this site region with content from Builder"
    }, {
      label: "Append",
      value: "afterEnd",
      helperText: "Append Builder content after the chosen site region"
    }]
  }, {
    name: "selector",
    type: "builder:domSelector"
  }]
});
var get = function get(e, t, n) {
    var i = String.prototype.split.call(t, /[,[\].]+?/).filter(Boolean).reduce(function (e, t) {
      return null != e ? e[t] : e;
    }, e);
    return void 0 === i || i === e ? n : i;
  },
  MULTIPART_CONTENT_TYPE = "multipart/form-data",
  JSON_CONTENT_TYPE = "application/json",
  ENCODED_CONTENT_TYPE = "application/x-www-form-urlencoded",
  FormComponent = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.ref = null, t.state = {
        state: "unsubmitted",
        responseData: null,
        formErrorMessage: ""
      }, t;
    }
    return __extends(t, e), Object.defineProperty(t.prototype, "submissionState", {
      get: function get() {
        return Builder.isEditing && this.props.previewState || this.state.state;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function () {
      var e = this;
      return jsx(BuilderStoreContext.Consumer, null, function (t) {
        return jsx(BuilderStoreContext.Provider, {
          value: _assign(_assign({}, t), {
            state: _assign(_assign({}, t.state), {
              formErrorMessage: e.state.formErrorMessage
            })
          })
        }, jsx("form", _assign({
          validate: e.props.validate,
          ref: function ref(t) {
            return e.ref = t;
          },
          action: !e.props.sendWithJs && e.props.action,
          method: e.props.method,
          name: e.props.name,
          onSubmit: function onSubmit(t) {
            var n,
              i = e.props.sendWithJs || "email" === e.props.sendSubmissionsTo;
            if ("zapier" === e.props.sendSubmissionsTo) t.preventDefault();else if (i) {
              if (!e.props.action && "email" !== e.props.sendSubmissionsTo) return void t.preventDefault();
              t.preventDefault();
              var r = t.currentTarget,
                o = e.props.customHeaders || {},
                a = void 0,
                s = new FormData(r),
                l = Array.from(t.currentTarget.querySelectorAll("input,select,textarea")).filter(function (e) {
                  return !!e.name;
                }).map(function (e) {
                  var t,
                    n = e.name;
                  if (e instanceof HTMLInputElement) {
                    if ("radio" === e.type) {
                      if (e.checked) return {
                        key: n,
                        value: t = e.name
                      };
                    } else if ("checkbox" === e.type) t = e.checked;else if ("number" === e.type || "range" === e.type) {
                      var i = e.valueAsNumber;
                      isNaN(i) || (t = i);
                    } else t = "file" === e.type ? e.files : e.value;
                  } else t = e.value;
                  return {
                    key: n,
                    value: t
                  };
                }),
                u = e.props.contentType;
              if ("email" === e.props.sendSubmissionsTo && (u = MULTIPART_CONTENT_TYPE), Array.from(l).forEach(function (e) {
                var t = e.value;
                (t instanceof File || Array.isArray(t) && t[0] instanceof File || t instanceof FileList) && (u = MULTIPART_CONTENT_TYPE);
              }), u === MULTIPART_CONTENT_TYPE) a = s;else if (u === JSON_CONTENT_TYPE) {
                var d = {};
                Array.from(l).forEach(function (e) {
                  var t = e.value,
                    n = e.key;
                  set(d, n, t);
                }), a = JSON.stringify(d);
              } else {
                if (u !== ENCODED_CONTENT_TYPE) return void console.error("Unsupported content type: ", u);
                a = Array.from(l).map(function (e) {
                  var t = e.value,
                    n = e.key;
                  return encodeURIComponent(n) + "=" + encodeURIComponent(t);
                }).join("&");
              }
              u && u !== MULTIPART_CONTENT_TYPE && (i && (null === (n = e.props.action) || void 0 === n ? void 0 : n.includes("zapier.com")) || (o["content-type"] = u));
              var c = new CustomEvent("presubmit", {
                detail: {
                  body: a
                }
              });
              if (e.ref && (e.ref.dispatchEvent(c), c.defaultPrevented)) return;
              e.setState(_assign(_assign({}, e.state), {
                state: "sending"
              }));
              var p = "".concat("dev" === builder.env ? "http://localhost:5000" : "https://builder.io", "/api/v1/form-submit?apiKey=").concat(builder.apiKey, "&to=").concat(btoa(e.props.sendSubmissionsToEmail || ""), "&name=").concat(encodeURIComponent(e.props.name || ""));
              fetch("email" === e.props.sendSubmissionsTo ? p : e.props.action, {
                body: a,
                headers: o,
                method: e.props.method || "post"
              }).then(function (t) {
                return __awaiter(e, void 0, void 0, function () {
                  var e, n, i, r, o;
                  return __generator(this, function (a) {
                    switch (a.label) {
                      case 0:
                        return (n = t.headers.get("content-type")) && -1 !== n.indexOf(JSON_CONTENT_TYPE) ? [4, t.json()] : [3, 2];
                      case 1:
                        return e = a.sent(), [3, 4];
                      case 2:
                        return [4, t.text()];
                      case 3:
                        e = a.sent(), a.label = 4;
                      case 4:
                        if (!t.ok && this.props.errorMessagePath && (i = get(e, this.props.errorMessagePath)) && ("string" != typeof i && (i = JSON.stringify(i)), this.setState(_assign(_assign({}, this.state), {
                          formErrorMessage: i
                        }))), this.setState(_assign(_assign({}, this.state), {
                          responseData: e,
                          state: t.ok ? "success" : "error"
                        })), t.ok) {
                          if (r = new CustomEvent("submit:success", {
                            detail: {
                              res: t,
                              body: e
                            }
                          }), this.ref) {
                            if (this.ref.dispatchEvent(r), r.defaultPrevented) return [2];
                            !1 !== this.props.resetFormOnSubmit && this.ref.reset();
                          }
                          this.props.successUrl && (this.ref ? (o = new CustomEvent("route", {
                            detail: {
                              url: this.props.successUrl
                            }
                          }), this.ref.dispatchEvent(o), o.defaultPrevented || (location.href = this.props.successUrl)) : location.href = this.props.successUrl);
                        }
                        return [2];
                    }
                  });
                });
              }, function (t) {
                var n = new CustomEvent("submit:error", {
                  detail: {
                    error: t
                  }
                });
                e.ref && (e.ref.dispatchEvent(n), n.defaultPrevented) || e.setState(_assign(_assign({}, e.state), {
                  responseData: t,
                  state: "error"
                }));
              });
            }
          }
        }, e.props.attributes), e.props.builderBlock && e.props.builderBlock.children && e.props.builderBlock.children.map(function (e, t) {
          return jsx(BuilderBlock$1, {
            key: e.id,
            block: e
          });
        }), "error" === e.submissionState && jsx(BuilderBlocks, {
          dataPath: "errorMessage",
          blocks: e.props.errorMessage
        }), "sending" === e.submissionState && jsx(BuilderBlocks, {
          dataPath: "sendingMessage",
          blocks: e.props.sendingMessage
        }), "error" === e.submissionState && e.state.responseData && jsx("pre", {
          className: "builder-form-error-text",
          css: {
            padding: 10,
            color: "red",
            textAlign: "center"
          }
        }, JSON.stringify(e.state.responseData, null, 2)), "success" === e.submissionState && jsx(BuilderBlocks, {
          dataPath: "successMessage",
          blocks: e.props.successMessage
        })));
      });
    }, t;
  }(React__default.Component),
  Form = withBuilder(FormComponent, {
    name: "Form:Form",
    defaults: {
      responsiveStyles: {
        large: {
          marginTop: "15px",
          paddingBottom: "15px"
        }
      }
    },
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
    inputs: [{
      name: "sendSubmissionsTo",
      type: "string",
      enum: [{
        label: "Send to email",
        value: "email",
        helperText: "Send form submissions to the email address of your choosing"
      }, {
        label: "Custom",
        value: "custom",
        helperText: "Handle where the form requests go manually with a little code, e.g. to your own custom backend"
      }],
      defaultValue: "email"
    }, {
      name: "sendSubmissionsToEmail",
      type: "string",
      required: !0,
      defaultValue: "your@email.com",
      showIf: 'options.get("sendSubmissionsTo") === "email"'
    }, {
      name: "sendWithJs",
      type: "boolean",
      helperText: "Set to false to use basic html form action",
      defaultValue: !0,
      showIf: 'options.get("sendSubmissionsTo") === "custom"'
    }, {
      name: "name",
      type: "string",
      defaultValue: "My form"
    }, {
      name: "action",
      type: "string",
      helperText: "URL to send the form data to",
      showIf: 'options.get("sendSubmissionsTo") === "custom"'
    }, {
      name: "contentType",
      type: "string",
      defaultValue: JSON_CONTENT_TYPE,
      advanced: !0,
      enum: [JSON_CONTENT_TYPE, MULTIPART_CONTENT_TYPE, ENCODED_CONTENT_TYPE],
      showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
    }, {
      name: "method",
      type: "string",
      showIf: 'options.get("sendSubmissionsTo") === "custom"',
      defaultValue: "POST",
      advanced: !0
    }, {
      name: "previewState",
      type: "string",
      enum: ["unsubmitted", "sending", "success", "error"],
      defaultValue: "unsubmitted",
      helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
      showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
    }, {
      name: "successUrl",
      type: "url",
      helperText: "Optional URL to redirect the user to on form submission success",
      showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
    }, {
      name: "resetFormOnSubmit",
      type: "boolean",
      showIf: function showIf(e) {
        return "custom" === e.get("sendSubmissionsTo") && !0 === e.get("sendWithJs");
      },
      advanced: !0
    }, {
      name: "successMessage",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            marginTop: "10px"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<span>Thanks!</span>"
          }
        }
      }]
    }, {
      name: "validate",
      type: "boolean",
      defaultValue: !0,
      advanced: !0
    }, {
      name: "errorMessagePath",
      type: "text",
      advanced: !0,
      helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
    }, {
      name: "errorMessage",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            marginTop: "10px"
          }
        },
        bindings: {
          "component.options.text": "state.formErrorMessage || block.component.options.text"
        },
        component: {
          name: "Text",
          options: {
            text: "<span>Form submission error :( Please check your answers and try again</span>"
          }
        }
      }]
    }, {
      name: "sendingMessage",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            marginTop: "10px"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<span>Sending...</span>"
          }
        }
      }]
    }, _assign(_assign({
      name: "customHeaders",
      type: "map"
    }, {
      valueType: {
        type: "string"
      }
    }), {
      advanced: !0,
      showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
    })],
    noWrap: !0,
    canHaveChildren: !0,
    defaultChildren: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Enter your name</span>"
        }
      }
    }, {
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Form:Input",
        options: {
          name: "name",
          placeholder: "Jane Doe"
        }
      }
    }, {
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Enter your email</span>"
        }
      }
    }, {
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Form:Input",
        options: {
          name: "email",
          placeholder: "jane@doe.com"
        }
      }
    }, {
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Form:SubmitButton",
        options: {
          text: "Submit"
        }
      }
    }]
  }),
  FormInputComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      return React__default.createElement("input", _assign({
        key: Builder.isEditing && this.props.defaultValue ? this.props.defaultValue : "default-key",
        placeholder: this.props.placeholder,
        type: this.props.type,
        name: this.props.name,
        value: this.props.value,
        defaultValue: this.props.defaultValue,
        required: this.props.required
      }, this.props.attributes));
    }, t;
  }(React__default.Component),
  FormInput = withBuilder(FormInputComponent, {
    name: "Form:Input",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
    inputs: [{
      name: "type",
      type: "text",
      enum: ["text", "number", "email", "url", "checkbox", "radio", "range", "date", "datetime-local", "search", "tel", "time", "file", "month", "week", "password", "color", "hidden"],
      defaultValue: "text"
    }, {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
    }, {
      name: "placeholder",
      type: "string",
      defaultValue: "Hello there",
      helperText: "Text to display when there is no value"
    }, {
      name: "defaultValue",
      type: "string"
    }, {
      name: "value",
      type: "string",
      advanced: !0
    }, {
      name: "required",
      type: "boolean",
      helperText: "Is this input required to be filled out to submit a form",
      defaultValue: !1
    }],
    noWrap: !0,
    static: !0,
    defaultStyles: {
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingLeft: "10px",
      paddingRight: "10px",
      borderRadius: "3px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#ccc"
    }
  }),
  FormSubmitButtonComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      return React__default.createElement("button", _assign({
        type: "submit"
      }, this.props.attributes), this.props.text);
    }, t;
  }(React__default.Component),
  FormSubmitButton = withBuilder(FormSubmitButtonComponent, {
    name: "Form:SubmitButton",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",
    defaultStyles: {
      appearance: "none",
      paddingTop: "15px",
      paddingBottom: "15px",
      paddingLeft: "25px",
      paddingRight: "25px",
      backgroundColor: "#3898EC",
      color: "white",
      borderRadius: "4px",
      cursor: "pointer"
    },
    inputs: [{
      name: "text",
      type: "text",
      defaultValue: "Click me"
    }],
    static: !0,
    noWrap: !0
  }),
  LabelComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      return React__default.createElement("label", _assign({
        htmlFor: this.props.for
      }, this.props.attributes), this.props.text && React__default.createElement("span", {
        className: "builder-label-text",
        dangerouslySetInnerHTML: {
          __html: this.props.text
        }
      }), this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e) {
        return React__default.createElement(BuilderBlock$1, {
          key: e.id,
          block: e
        });
      }));
    }, t;
  }(React__default.Component),
  Label = withBuilder(LabelComponent, {
    name: "Form:Label",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F9322342f04b545fb9a8091cd801dfb5b",
    inputs: [{
      name: "text",
      type: "html",
      richText: !0,
      defaultValue: "Label"
    }, {
      name: "for",
      type: "text",
      helperText: "The name of the input this label is for",
      advanced: !0
    }],
    noWrap: !0,
    static: !0,
    canHaveChildren: !0
  }),
  FormSelectComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      var e = this.props.options;
      return React__default.createElement("select", _assign({
        value: this.props.value,
        key: Builder.isEditing && this.props.defaultValue ? this.props.defaultValue : "default-key",
        defaultValue: this.props.defaultValue,
        name: this.props.name
      }, this.props.attributes), e && e.map(function (e) {
        return React__default.createElement("option", {
          value: e.value
        }, e.name || e.value);
      }));
    }, t;
  }(React__default.Component),
  FormSelect = withBuilder(FormSelectComponent, {
    name: "Form:Select",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
    defaultStyles: {
      alignSelf: "flex-start"
    },
    inputs: [{
      name: "options",
      type: "list",
      required: !0,
      subFields: [{
        name: "value",
        type: "text",
        required: !0
      }, {
        name: "name",
        type: "text"
      }],
      defaultValue: [{
        value: "option 1"
      }, {
        value: "option 2"
      }]
    }, {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every select in a form needs a unique name describing what it gets, e.g. "email"'
    }, {
      name: "defaultValue",
      type: "string"
    }, {
      name: "value",
      type: "string",
      advanced: !0
    }, {
      name: "required",
      type: "boolean",
      defaultValue: !1
    }],
    static: !0,
    noWrap: !0
  }),
  TextAreaComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      return React__default.createElement("textarea", _assign({
        placeholder: this.props.placeholder,
        name: this.props.name,
        value: this.props.value,
        defaultValue: this.props.defaultValue
      }, this.props.attributes));
    }, t;
  }(React__default.Component),
  TextArea = withBuilder(TextAreaComponent, {
    name: "Form:TextArea",
    image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",
    inputs: [{
      advanced: !0,
      name: "value",
      type: "string"
    }, {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every input in a form needs a unique name describing what it gets, e.g. "email"'
    }, {
      name: "defaultValue",
      type: "string"
    }, {
      name: "placeholder",
      type: "string",
      defaultValue: "Hello there"
    }, {
      name: "required",
      type: "boolean",
      defaultValue: !1
    }],
    defaultStyles: {
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingLeft: "10px",
      paddingRight: "10px",
      borderRadius: "3px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#ccc"
    },
    static: !0,
    noWrap: !0
  }),
  ImgComponent = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return __extends(t, e), t.prototype.render = function () {
      var e = this.props.attributes || {};
      return React__default.createElement("img", _assign({}, this.props.attributes, {
        src: this.props.image || e.src
      }));
    }, t;
  }(React__default.Component),
  Img = withBuilder(ImgComponent, {
    name: "Raw:Img",
    hideFromInsertMenu: !0,
    image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
    inputs: [{
      name: "image",
      bubble: !0,
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      required: !0
    }],
    noWrap: !0,
    static: !0
  }),
  RawText = function RawText(e) {
    var t = e.attributes || {};
    return React.createElement("span", {
      className: (null == t ? void 0 : t.class) || (null == t ? void 0 : t.className),
      dangerouslySetInnerHTML: {
        __html: e.text || ""
      }
    });
  };
function useIsPreviewing() {
  var e = useState(!1),
    t = e[0],
    n = e[1];
  return useEffect(function () {
    (Builder.isEditing || Builder.isPreviewing) && n(!0);
  }, []), t;
}
Builder.registerComponent(RawText, {
  name: "Builder:RawText",
  hideFromInsertMenu: !0,
  inputs: [{
    name: "text",
    bubble: !0,
    type: "longText",
    required: !0
  }]
}), Builder.isReact = !0;
export { BuilderAsyncRequestsContext, BuilderBlock, BuilderBlock$1 as BuilderBlockComponent, BuilderBlocks, BuilderComponent, BuilderContent, BuilderMetaContext, BuilderComponent as BuilderPage, BuilderStoreContext, Button, Columns, CustomCode, Slot as Dropzone, Embed, Form, FormInput, FormSelect, FormSubmitButton, Fragment, Image, Img, Label, Mutation, RawText, BuilderComponent as RenderContent, Router, Section, StateProvider, Symbol$1 as Symbol, Text, TextArea, Video, getSrcSet, noWrap, onChange, stringToFunction, updateMetadata, useIsPreviewing, withBuilder, withChildren };